{
  "common": {
    "main": {
      "project": "Proje",
      "form": "Form",
      "version": "Sürüm",
      "formSettings": "Form Ayarları",
      "user": "Kullanıcı",
      "organization": "Kuruluş",
      "server": "Sunucu",
      "url": "URL"
    },
    "buttons": {
      "ok": "Tamam",
      "cancel": "İptal",
      "save": "Kaydet",
      "add": "Ekle",
      "edit": "Düzenle",
      "delete": "Sil",
      "refresh": "Yenile",
      "create": "Oluştur",
      "submit": "Gönder",
      "clear": "Temizle",
      "selectAll": "Tümünü Seç",
      "back": "Geri",
      "next": "İleri",
      "previous": "Önceki",
      "close": "Kapat",
      "confirm": "Onayla",
      "yes": "Evet",
      "no": "Hayır",
      "search": "Ara",
      "filter": "Filtrele",
      "export": "Dışa Aktar",
      "import": "İçe Aktar",
      "download": "İndir",
      "upload": "Yükle",
      "view": "Görüntüle",
      "preview": "Önizleme",
      "copy": "Kopyala",
      "assign": "Ata",
      "unassign": "Ata Kaldır",
      "retry": "Tekrar Dene",
      "loading": "Yükleniyor..."
    },
    "dialogs": {
      "cancel": "İptal",
      "close": "Kapat",
      "confirm": "Onayla",
      "delete": "Sil",
      "save": "Değişiklikleri kaydet",
      "confirmTitle": "Eylemi onayla",
      "unsavedChanges": {
        "title": "Kaydedilmemiş değişiklikler",
        "message": "Kaydedilmemiş değişiklikler var. Kaydetmeden kapatılsın mı?"
      }
    },
    "table": {
      "headers": {
        "name": "Ad",
        "description": "Açıklama",
        "statistics": "İstatistikler",
        "status": "Durum",
        "actions": "İşlemler",
        "createdAt": "Oluşturulma Tarihi",
        "updatedAt": "Güncellenme Tarihi",
        "created": "Oluşturuldu",
        "updated": "Güncellendi",
        "type": "Tür",
        "version": "Sürüm",
        "id": "ID",
        "email": "E-posta",
        "role": "Rol",
        "user": "Kullanıcı",
        "project": "Proje",
        "organization": "Kuruluş",
        "lastSubmission": "Son Gönderim",
        "server": "Sunucu",
        "url": "URL",
        "format": "Biçim",
        "count": "Sayı",
        "size": "Boyut",
        "date": "Tarih",
        "time": "Saat",
        "severity": "Önem",
        "field": "Birincil Alan",
        "form": "Form",
        "state": "Durum",
        "roles": "Roller",
        "groups": "Gruplar",
        "formId": "Form ID",
        "permissions": "İzinler",
        "enabled": "Etkin",
        "disabled": "Devre Dışı",
        "submissions": "Gönderimler",
        "publishedAt": "Yayın Tarihi"
      },
      "pagination": {
        "page": "Sayfa",
        "of": "/",
        "perPage": "sayfa başına",
        "showing": "Gösterilen",
        "to": "-",
        "totalEntries": "toplam kayıt",
        "resultsText": "sonuç.",
        "perPageText": "Sayfa başına sonuç"
      },
      "ariaLabels": {
        "viewDetails": "Detayları görüntüle",
        "edit": "Düzenle",
        "delete": "Sil",
        "previousPage": "Önceki sayfa",
        "nextPage": "Sonraki sayfa"
      }
    },
    "status": {
      "active": "Aktif",
      "inactive": "Pasif",
      "archived": "Arşivlenmiş",
      "draft": "Taslak",
      "published": "Yayınlandı",
      "pending": "Beklemede",
      "completed": "Tamamlandı",
      "failed": "Başarısız",
      "success": "Başarılı",
      "error": "Hata",
      "warning": "Uyarı",
      "info": "Bilgi",
      "loading": "Yükleniyor",
      "notSet": "Ayarlanmamış",
      "notSpecified": "Belirtilmemiş",
      "notAvailable": "Yok",
      "unknown": "Bilinmiyor",
      "enabled": "Etkin",
      "disabled": "Devre Dışı"
    },
    "messages": {
      "confirmDelete": "Silmek istediğinizden emin misiniz",
      "confirmDeleteWithName": "\"{name}\" öğesini silmek istediğinizden emin misiniz?",
      "deleteSuccess": "Başarıyla silindi",
      "deleteError": "Silinirken hata",
      "saveSuccess": "Başarıyla kaydedildi",
      "saveError": "Kaydedilirken hata",
      "createSuccess": "Başarıyla oluşturuldu",
      "createError": "Oluşturulurken hata",
      "updateSuccess": "Başarıyla güncellendi",
      "updateError": "Güncellenirken hata",
      "error": "Hata",
      "loadError": "Yüklenirken hata",
      "noData": "Veri yok",
      "noResults": "Sonuç yok",
      "required": "Bu alan zorunludur",
      "invalidEmail": "Lütfen geçerli bir e-posta girin",
      "confirmDeleteWithType": "\"{name}\" ({type}) öğesini silmek istediğinizden emin misiniz?",
      "bulkOperationSuccess": "Toplu işlem başarıyla tamamlandı",
      "bulkOperationError": "Toplu işlem sırasında hata",
      "operationFailed": "İşlem gerçekleştirilemedi",
      "unsavedChanges": "Formda kaydedilmemiş değişiklikler var. Kapatmak istediğinizden emin misiniz?",
      "created": "oluşturuldu",
      "updated": "güncellendi",
      "invalidUrl": "Please enter a valid URL"
    },
    "statistics": {
      "title": "İstatistikler",
      "subtitle": "Organizasyon genelinde istatistikleri, form durumlarını ve proje etkinliklerini gözden geçirin.",
      "overall": "Genel İstatistikler",
      "byState": "Duruma Göre Formlar",
      "projectDetails": "Proje Detayları",
      "projectLedger": "Proje kaydı",
      "pipeline": "Durum",
      "projectCount": "{count} proje",
      "noActiveForms": "Aktif form yok",
      "projects": "Projeler",
      "totalForms": "Toplam Form",
      "activeForms": "Aktif Formlar",
      "submissions": "Gönderimler",
      "forms": "Formlar",
      "lastUpdated": "Son güncelleme",
      "noDataToDisplay": "Gösterilecek veri yok"
    },
    "viewMode": {
      "cards": "Kartlar",
      "table": "Tablo",
      "list": "Liste",
      "grid": "Izgara"
    },
    "time": {
      "today": "bugün",
      "yesterday": "dün",
      "thisWeek": "bu hafta",
      "lastWeek": "geçen hafta",
      "thisMonth": "bu ay",
      "lastMonth": "geçen ay",
      "allTime": "tüm zamanlar",
      "last7Days": "Son 7 gün",
      "last30Days": "Son 30 gün",
      "last90Days": "Son 90 gün",
      "customRange": "Özel aralık",
      "startDate": "Başlangıç tarihi",
      "endDate": "Bitiş tarihi",
      "justNow": "Az önce",
      "minutesAgo": "{count} dk önce",
      "hoursAgo": "{count} sa önce",
      "daysAgo": "{count} gün önce",
      "never": "Hiçbir zaman"
    },
    "placeholders": {
      "enterName": "Ad girin",
      "enterDescription": "Açıklama girin",
      "enterEmail": "E-posta girin",
      "enterUrl": "URL girin",
      "search": "Ara...",
      "selectOption": "Seçenek seçin"
    },
    "formState": {
      "title": "Form Durumunu Değiştir",
      "form": "Form",
      "currentStatus": "Mevcut durum",
      "newStatus": "Yeni durum",
      "pleaseSelectStatus": "Lütfen bir durum seçin",
      "statusChangedSuccessfully": "Form {formName} durumu başarıyla {status} olarak değiştirildi",
      "errorChangingStatus": "Form durumu değiştirilirken hata"
    }
  },
  "admin": {
    "agent": {
      "title": "AI Agent",
      "subtitle": "Yapay zeka ajanı entegrasyonunu izleyin ve yönetin",
      "back": "Dashboard'a geri dön",
      "health": {
        "title": "Entegrasyon sağlığı",
        "checkNow": "Şimdi kontrol et",
        "latency": "Gecikme",
        "lastCheck": "Son kontrol"
      },
      "stats": {
        "activeSubs": "Aktif abonelikler",
        "requestsToday": "Bugün istekler",
        "tokensToday": "Bugün tokenler",
        "nearQuota": "Kotaya yakın org",
        "activeSubsHint": "toplam {total}",
        "nearQuotaHint": ">%80 kullanıldı"
      },
      "config": {
        "title": "Konfigürasyon (yalnızca okunur)"
      },
      "jobs": {
        "title": "RQ Jobs (analitik raporlar)",
        "empty": "Yakın zamanda job yok"
      },
      "digests": {
        "title": "Proaktif toplar",
        "trigger": "Manuel tetikle",
        "historyTitle": "Topar geçmişi",
        "historyEmpty": "Topar çalıştırmaları henüz kaydedilmedi."
      },
      "selfHeal": {
        "title": "Kendini iyileştirme işleri",
        "trigger": "Şimdi çalıştır"
      },
      "incident": {
        "banner": "Hermes veya MCP entegrasyonu sağlıksız. Ajanın özellikleri bozulabilir.",
        "title": "Dikkat gerekli"
      },
      "subscriptions": {
        "title": "Agent abonelikleri",
        "subtitle": "Organizasyonlar için seviyeler, kotalar ve özellikleri yönetin",
        "searchPlaceholder": "Kuruluş ara...",
        "allTiers": "Tüm katmanlar",
        "editTitle": "Aboneliği düzenle",
        "resetTitle": "Kullanımı sıfırla",
        "resetMessage": "{name} için kullanım sayaçları sıfırlansın mı?",
        "resetConfirm": "Sıfırla",
        "empty": "Abonelik bulunamadı",
        "tierDefaultsTitle": "Katman varsayılanları",
        "tierDefaultsHint": "Backend SSOT referans limitleri. Düzenleme formunda katman değiştirmek bu değerleri uygular (geçersiz kılmalar hâlâ mümkün).",
        "columns": {
          "org": "Kuruluş",
          "tier": "Katman",
          "fiveHour": "5s",
          "week": "Hafta",
          "month": "Ay",
          "features": "Özellikler"
        },
        "tierDefaults": {
          "fiveHour": "5s (istek / token)",
          "week": "Hafta (istek / token)",
          "month": "Ay (istek / token)"
        }
      },
      "usage": {
        "title": "Agent kullanımı",
        "subtitle": "Organizasyonlar arası çağrı logu",
        "orgIdPlaceholder": "Kuruluş ID",
        "allFeatures": "Tüm özellikler",
        "empty": "Kullanım olayı yok",
        "columns": {
          "time": "Zaman",
          "org": "Kuruluş",
          "user": "Kullanıcı",
          "feature": "Özellik",
          "tokens": "Token"
        }
      },
      "audit": {
        "title": "Araç çağrı audit",
        "subtitle": "MCP araç çağrı logu (özellikle yazma eylemleri)",
        "orgIdPlaceholder": "Kuruluş ID",
        "toolPlaceholder": "Araç adı",
        "writeOnly": "Yalnızca yazma araçları",
        "detailTitle": "Denetim detayı",
        "detail": "Detay",
        "empty": "Denetim kaydı yok",
        "write": "Yazma",
        "read": "Okuma",
        "columns": {
          "time": "Zaman",
          "org": "Kuruluş",
          "tool": "Araç",
          "write": "Yazma"
        }
      },
      "sections": {
        "metrics": "Nabız"
      }
    },
    "dialogs": {
      "deleteProject": {
        "title": "Projeyi sil",
        "message": "Bu işlem geri alınamaz. Bağlı tüm formlar kaldırılacak.",
        "formsCount": "Kaldırılacak form: {count}",
        "confirm": "Kalıcı olarak sil"
      },
      "deleteOrganization": {
        "title": "Organizasyonu sil",
        "message": "Bu işlem geri alınamaz. Tüm projeler ve kullanıcılar etkilenecek.",
        "confirm": "Kalıcı olarak sil"
      },
      "deleteForm": {
        "title": "Formu sil",
        "message": "Bu işlem geri alınamaz.",
        "confirm": "Kalıcı olarak sil"
      },
      "deleteUser": {
        "title": "Kullanıcıyı sil",
        "message": "Bu işlem geri alınamaz. Kullanıcı tüm organizasyonlara erişimini kaybedecek.",
        "confirm": "Kalıcı olarak sil"
      },
      "projectDetails": "Proje: {name}",
      "organizationDetails": "Organizasyon: {name}",
      "formDetails": "Form: {name}",
      "userDetails": "Kullanıcı: {name}",
      "close": "Kapat",
      "createUser": {
        "title": "Kullanıcı oluştur"
      },
      "editUser": {
        "title": "Kullanıcı düzenle"
      },
      "fullName": "Ad ve soyad",
      "superuser": "Süper kullanıcı",
      "active": "Aktif"
    },
    "back": "Kontrol paneline dön",
    "chrome": {
      "sessionLabel": "Süper kullanıcı · tüm işlemler kaydedilir",
      "exit": "Moddan çık",
      "menuTitle": "Yönetim",
      "sessionWarning": "Yönetici oturumu {time} içinde sona erecek.",
      "extendSession": "Oturumu uzat"
    },
    "nav": {
      "groups": {
        "overview": "Genel bakış",
        "directory": "Dizin",
        "access": "Erişim",
        "integrations": "Entegrasyonlar",
        "platform": "Altyapı"
      },
      "dashboard": "Kontrol paneli",
      "analytics": "Analitik",
      "users": "Kullanıcılar",
      "organizations": "Kuruluşlar",
      "projects": "Projeler",
      "forms": "Formlar",
      "roles": "Roller ve izinler",
      "permissionGroups": "İzin grupları",
      "agent": "Hermes Agent",
      "agentDashboard": "Ajan kontrol paneli",
      "agentSubscriptions": "Ajan abonelikleri",
      "agentUsage": "Ajan kullanımı",
      "agentAudit": "Ajan denetimi",
      "globalOdk": "Global ODK sunucuları",
      "system": "Sistem",
      "audit": "Denetim",
      "subscriptions": "Faturalandırma"
    },
    "pagination": {
      "shown": "{total} kayıttan {start} - {end} gösteriliyor",
      "pageOf": "Sayfa {page} / {pages}",
      "previous": "Önceki",
      "next": "Sonraki"
    },
    "common": {
      "tryAgain": "Tekrar dene",
      "showDeleted": "Silinenleri göster",
      "hideDeleted": "Silinenleri gizle",
      "showArchived": "Arşivlenenleri göster",
      "hideArchived": "Arşivlenenleri gizle",
      "allOrganizations": "Tüm kuruluşlar",
      "allProjects": "Tüm projeler",
      "allRoles": "Tüm roller",
      "allStatuses": "Tüm durumlar",
      "totalRecords": "Toplam kayıt: {count}",
      "orgIdPrefix": "Kur. #{id}",
      "projectIdPrefix": "Proje #{id}",
      "notSet": "Ayarlanmadı",
      "health": {
        "healthy": "Sağlıklı",
        "degraded": "Düşük performans",
        "disabled": "Devre dışı",
        "unhealthy": "Sağlıksız",
        "unknown": "Bilinmiyor"
      }
    },
    "pages": {
      "users": {
        "title": "Kullanıcı yönetimi",
        "subtitle": "Tüm sistem kullanıcılarını görüntüle ve yönet",
        "addUser": "Kullanıcı ekle",
        "searchPlaceholder": "Kullanıcı ara...",
        "superuserBadge": "Süper kullanıcı",
        "userBadge": "Kullanıcı",
        "statsTotal": "Toplam",
        "statsSuperusers": "Süper kullanıcılar",
        "statsOwners": "Sahipler",
        "statsActive": "Aktif",
        "loadError": "Kullanıcılar yüklenemedi",
        "empty": "Mevcut filtrelerle eşleşen kullanıcı yok"
      },
      "organizations": {
        "title": "Kuruluş yönetimi",
        "subtitle": "Tüm sistem kuruluşlarını görüntüle ve yönet",
        "searchPlaceholder": "Kuruluş adı veya açıklamasına göre ara...",
        "sectionTitle": "Kuruluşlar",
        "loading": "Kuruluşlar yükleniyor...",
        "empty": "Kuruluş bulunamadı",
        "loadError": "Kuruluşlar yüklenemedi",
        "restored": "Kuruluş geri yüklendi",
        "restoreError": "Kuruluş geri yüklenemedi",
        "owner": "Sahip",
        "created": "Oluşturuldu",
        "deletedBadge": "Silindi",
        "activeBadge": "Aktif",
        "agentSubscription": "Ajan aboneliği",
        "statsTotal": "Toplam kuruluş",
        "statsActive": "Aktif",
        "statsProjects": "Projeler",
        "statsForms": "Formlar"
      },
      "projects": {
        "title": "Proje yönetimi",
        "subtitle": "Tüm sistem projelerini görüntüle ve yönet",
        "searchPlaceholder": "Proje adı veya açıklamasına göre ara...",
        "sectionTitle": "Projeler",
        "loading": "Projeler yükleniyor...",
        "empty": "Proje bulunamadı",
        "loadError": "Projeler yüklenemedi",
        "archived": "Proje arşivlendi",
        "unarchived": "Proje arşivden çıkarıldı",
        "archiveError": "Proje arşivlenemedi",
        "unarchiveError": "Proje arşivden çıkarılamadı",
        "created": "Oluşturuldu",
        "archivedBadge": "Arşivlendi",
        "activeBadge": "Aktif",
        "statsTotal": "Toplam proje",
        "statsActive": "Aktif",
        "statsArchived": "Arşivlenmiş",
        "statsForms": "Formlar"
      },
      "forms": {
        "title": "Form yönetimi",
        "subtitle": "Tüm sistem formlarını görüntüle ve yönet",
        "searchPlaceholder": "Form adı veya XML ID ile ara...",
        "sectionTitle": "Formlar",
        "loading": "Formlar yükleniyor...",
        "empty": "Form bulunamadı",
        "loadError": "Formlar yüklenemedi",
        "deletedToast": "Form silindi olarak işaretlendi",
        "restoredToast": "Form geri yüklendi",
        "deleteError": "Form silinemedi",
        "restoreError": "Form geri yüklenemedi",
        "created": "Oluşturuldu",
        "deletedBadge": "Silindi",
        "activeBadge": "Aktif",
        "importedBadge": "İçe aktarıldı",
        "statsTotal": "Toplam form",
        "statsActive": "Aktif",
        "statsDeleted": "Silindi",
        "statsImported": "İçe aktarıldı"
      },
      "permissionGroups": {
        "title": "İzin grupları",
        "subtitle": "İzin gruplarını yönet ve kullanıcılara ata",
        "createGroup": "Grup oluştur",
        "sectionTitle": "İzin grupları",
        "searchPlaceholder": "Grup ara...",
        "emptyFilter": "Mevcut aramayla eşleşen grup yok",
        "restoreError": "İzin grubu geri yüklenemedi",
        "deleteError": "İzin grubu silinemedi",
        "emptyTitle": "İzin grubu bulunamadı",
        "emptyBody": "Başlamak için ilk izin grubunu oluşturun",
        "deleteTitle": "Grubu sil",
        "deleteMessage": "\"{name}\" grubunu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
        "restoreTitle": "Geri yükle",
        "users": "Kullanıcılar",
        "statsTotal": "Toplam grup",
        "statsActive": "Aktif gruplar",
        "statsAssignments": "Atamalar",
        "loadError": "İzin grupları yüklenemedi",
        "restored": "\"{name}\" grubu geri yüklendi",
        "deleted": "İzin grubu silindi",
        "saved": "İzin grubu kaydedildi",
        "modal": {
          "createTitle": "Create permission group",
          "editTitle": "Edit permission group",
          "createHeader": "New permission group",
          "editHeader": "Edit group",
          "createSubtitle": "Create a new group with a set of roles",
          "editSubtitle": "Modify permission group parameters",
          "nameLabel": "Group name",
          "namePlaceholder": "Enter group name",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Enter group description",
          "activeLabel": "Group is active",
          "activeHint": "Inactive groups cannot be assigned to users",
          "rolesTitle": "Group roles",
          "rolesSubtitle": "Select roles to include in this group",
          "selectAtLeastOneRole": "Select at least one role",
          "selectedRolesTitle": "Selected roles",
          "clickToRemove": "Click on a role to remove it from the group",
          "validation": {
            "nameRequired": "Name is required",
            "nameMinLength": "Name must contain at least 2 characters",
            "nameMaxLength": "Name must not exceed 50 characters"
          },
          "toasts": {
            "createSuccess": "Permission group created successfully",
            "updateSuccess": "Permission group updated successfully",
            "saveError": "Error saving permission group"
          }
        },
        "groupUsersModal": {
          "title": "Users in group \"{name}\"",
          "noDescription": "No description available",
          "rolesCount": "Roles in group: {count}",
          "usersCount": "Users in group ({count})",
          "empty": "No users in this group",
          "noName": "Unnamed",
          "active": "Active",
          "inactive": "Inactive",
          "superuser": "Superuser",
          "owner": "Owner",
          "loadError": "Error loading group users"
        }
      },
      "globalOdkServers": {
        "title": "Global ODK sunucuları",
        "subtitle": "Sistem genelinde ODK sunucuları oluştur ve yönet",
        "createServer": "Sunucu oluştur",
        "statsTotal": "Toplam sunucu",
        "statsTotalHint": "{count} (+{active} aktif)",
        "statsGlobal": "Küresel",
        "statsDefault": "Varsayılan",
        "testTitle": "Bağlantı testi sonucu",
        "testOk": "Bağlantı başarılı",
        "testFail": "Bağlantı başarısız",
        "testMethod": "Yöntem:",
        "testProjects": "Proje sayısı:",
        "testing": "Bağlantı test ediliyor...",
        "refreshTokenTitle": "API token yenile",
        "refreshTokenBody": "Sunucu için API token yenilemek üzere parolayı girin",
        "password": "Parola",
        "passwordPlaceholder": "Parolayı girin",
        "refreshTokenAction": "Token yenile",
        "requiredField": "Bu alan zorunludur",
        "searchPlaceholder": "Ad, URL veya kullanıcı adına göre ara...",
        "empty": "Global ODK sunucusu yok",
        "emptyHint": "Başlamak için ilk global ODK sunucusunu oluşturun.",
        "emptyFilter": "Mevcut aramayla eşleşen sunucu yok",
        "defaultBadge": "Varsayılan",
        "columns": {
          "server": "Sunucu",
          "user": "Kullanıcı",
          "visibility": "Görünürlük"
        },
        "visibility": {
          "GLOBAL": "Küresel",
          "ORGANIZATION": "Kuruluş",
          "SHARED": "Paylaşımlı"
        },
        "actions": {
          "test": "Bağlantıyı test et",
          "refreshToken": "Token yenile",
          "setDefault": "Varsayılan yap"
        },
        "deleteTitle": "Sunucuyu sil",
        "deleteMessage": "\"{name}\" sunucusu silinsin mi? Bu işlem geri alınamaz.",
        "setDefaultTitle": "Varsayılan sunucu ayarla",
        "setDefaultMessage": "\"{name}\" global varsayılan ODK sunucusu olarak ayarlansın mı?",
        "setDefaultConfirm": "Varsayılan yap",
        "toastCreated": "Sunucu oluşturuldu",
        "toastUpdated": "Sunucu güncellendi",
        "toastDeleted": "Sunucu silindi",
        "toastTestOk": "Bağlantı başarılı",
        "toastTokenRefreshed": "API token yenilendi",
        "toastDefaultSet": "Global varsayılan sunucu güncellendi",
        "form": {
          "createTitle": "Create global ODK server",
          "editTitle": "Edit global ODK server",
          "nameLabel": "Server name",
          "namePlaceholder": "Enter server name",
          "urlLabel": "Server URL",
          "urlPlaceholder": "https://example.com",
          "usernameLabel": "Username",
          "usernamePlaceholder": "Enter username",
          "passwordLabel": "Password",
          "passwordPlaceholder": "Enter password",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Server description (optional)",
          "globalDefaultLabel": "Global default server",
          "activeLabel": "Active server",
          "updateButton": "Update"
        }
      },
      "subscriptions": {
        "title": "Faturalandırma abonelikleri",
        "subtitle": "SaaS faturalandırma ve ödeme planları (Hermes Agent kotaları değil)",
        "stubBadge": "Yakında",
        "stubBody": "Faturalandırma ve ödeme abonelikleri geliştiriliyor. Bu sayfa faturalandırma yayınlandığında ticari planları yönetecek.",
        "stubAgentHint": "Hermes Agent katmanları, kotaları ve özellik bayrakları Entegrasyonlar → Hermes Agent → Abonelikler altında yönetilir.",
        "openAgentSubscriptions": "Ajan aboneliklerini aç"
      },
      "audit": {
        "title": "İşlem denetimi",
        "subtitle": "Süper kullanıcıların yönetim işlemleri günlüğü",
        "loadError": "Denetim günlüğü yüklenemedi.",
        "empty": "Henüz denetim kaydı yok",
        "time": "Zaman",
        "user": "Kullanıcı",
        "action": "İşlem",
        "details": "Detaylar",
        "emptyFilter": "Mevcut aramayla eşleşen kayıt yok",
        "searchPlaceholder": "Kullanıcı, işlem veya detaylara göre ara...",
        "actionKey": "İşlem anahtarı",
        "detailTitle": "Denetim kaydı"
      },
      "system": {
        "title": "Sistem sağlığı",
        "subtitle": "Altyapı tanılaması — durum, gecikme ve çalışma zamanı detayları",
        "loadError": "Sistem durumu yüklenemedi.",
        "serverInfo": "Çalışma zamanı detayları",
        "version": "Sürüm",
        "uptime": "Süreç çalışma süresi",
        "dbConnections": "DB bağlantıları (aktif)",
        "dbPool": "DB havuz boyutu",
        "components": {
          "server": "Sunucu",
          "database": "Veritabanı",
          "redis": "Redis",
          "api": "API",
          "agent": "Hermes Agent"
        },
        "attentionTitle": "Dikkat gerektiriyor",
        "attentionComponent": "{component}: {status}",
        "openAgent": "Ajanı aç",
        "componentsTitle": "Bileşenler",
        "dbLatency": "DB gecikmesi",
        "apiLatency": "API gecikmesi"
      },
      "analytics": {
        "title": "Analitik kontrol paneli",
        "subtitle": "Sistem geneli ve kullanıcı analitiği",
        "loadError": "Analitik yüklenemedi. Sıfır değerler gösteriliyor.",
        "totalUsers": "Toplam kullanıcı",
        "thisMonth": "Bu ay +{count}",
        "organizations": "Kuruluşlar",
        "growthPct": "%{pct} büyüme",
        "totalProjects": "Toplam proje",
        "totalForms": "Toplam form",
        "submissions": "Gönderimler",
        "userGrowth": "Kullanıcı büyümesi (aya göre)",
        "orgActivity": "Kuruluş etkinliği (projelere göre)",
        "noData": "Veri yok",
        "topOrgs": "En iyi kuruluşlar",
        "projectsCount": "{count} proje",
        "noOrgs": "Kuruluş yok",
        "recentActivity": "Son etkinlik",
        "noRecent": "Son etkinlik yok",
        "systemHealth": "Sistem sağlığı",
        "resources": "Kaynak kullanımı",
        "orgs": "Kuruluşlar",
        "projects": "Projeler",
        "forms": "Formlar",
        "health": {
          "api": "API",
          "database": "Veritabanı",
          "redis": "Redis",
          "websocket": "WebSocket",
          "agent": "Hermes Agent"
        }
      },
      "roles": {
        "title": "Roller ve izinler",
        "subtitle": "Platform rol kataloğu — izin grupları için yapı taşları",
        "searchPlaceholder": "Rolleri ara...",
        "loadError": "Roller yüklenemedi.",
        "emptyTitle": "Rol bulunamadı",
        "emptyFilter": "Aramayla eşleşen rol yok",
        "openGroups": "İzin grupları",
        "system": "Sistem",
        "custom": "Özel",
        "unused": "Hiçbir grupta kullanılmıyor",
        "columns": {
          "role": "Rol",
          "description": "Açıklama",
          "usedIn": "Gruplarda kullanım",
          "type": "Tür"
        },
        "labels": {
          "project_member": "Proje üyesi"
        },
        "descriptions": {
          "fallback": "Açıklama yok.",
          "manager": "Tam proje yönetimi ve kalite denetimi.",
          "project_member": "Minimum proje erişimi — ad ve formlar, gönderi verisi olmadan.",
          "data_viewer": "Gönderilere, izlemeye ve QC incelemesine salt okunur erişim.",
          "data_collector": "Saha verisi toplama ve gönderme.",
          "data_downloader": "Gönderi verisini dışa aktarma ve indirme.",
          "data_analyst": "QC işlemleri ve veri analizi.",
          "form_designer": "XLSForm oluşturma ve yönetme.",
          "qc_editor": "QC sonuçlarını ve bulgularını düzenleme."
        }
      }
    },
    "dashboard": {
      "title": "Genel bakış",
      "subtitle": "Platform nabzı ve son yönetici etkinliği",
      "errors": {
        "stats": "Sistem metrikleri yüklenemedi. Sıfırlar gösteriliyor.",
        "health": "Sistem sağlığı yüklenemedi.",
        "activities": "Son etkinlik yüklenemedi."
      },
      "attention": {
        "title": "Dikkat gerektiriyor",
        "server": "Sunucu sağlıksız durum bildiriyor.",
        "database": "Veritabanı sağlıksız durum bildiriyor.",
        "redis": "Redis sağlıksız durum bildiriyor.",
        "api": "API sağlıksız durum bildiriyor.",
        "agent": "Hermes Agent durumu: {status}.",
        "failedLogins": "Son 24 saatte {count} başarısız giriş denemesi.",
        "openSystem": "Sistemi aç",
        "openAgent": "Ajanı aç",
        "openAudit": "Denetimi aç"
      },
      "sections": {
        "metrics": "Dizin",
        "health": "Sağlık",
        "activity": "Son etkinlik"
      },
      "metrics": {
        "users": "Kullanıcılar",
        "usersHint": "Bugün +{count}",
        "orgs": "Kuruluşlar",
        "orgsHint": "Bu hafta +{count}",
        "projects": "Projeler",
        "projectsHint": "{count} aktif",
        "failedLogins": "Başarısız girişler",
        "failedLoginsHint": "Son 24 saat"
      },
      "health": {
        "server": "Sunucu",
        "database": "Veritabanı",
        "redis": "Redis",
        "api": "API",
        "agent": "Hermes Agent",
        "connections": "{count} bağlantı",
        "latency": "{ms} ms",
        "agentHint": "Bugün {count} istek"
      },
      "activity": {
        "viewAll": "Denetimi görüntüle",
        "empty": "Son yönetici etkinliği yok"
      }
    }
  },
  "agent": {
    "common": {
      "loading": "Agent abonelik yükleniyor...",
      "working": "Agent çalışıyor..."
    },
    "features": {
      "reports": "Raporlar",
      "qc": "QC asistan",
      "xlsform": "XLSForm",
      "share_links": "Share links",
      "auto_reports": "Auto-reports",
      "qc_rules": "QC rules"
    },
    "errors": {
      "generic": "Agent çağrısı başarısız oldu.",
      "endpointNotFound": "Bu ajan özelliği çalışan backend'de mevcut değil. Backend dev server'ı (.\\scripts\\dev.ps1) yeniden başlatın.",
      "timeout": "Agent yanıt vermedi. XLSForm asistanı 10 dakika sürebilir — tekrar deneyin.",
      "featureUnavailable": "Bu özellik planınızda mevcut değil.",
      "quotaExceeded": "Agent kota aşıldı.",
      "disabled": "AI agent geçici olarak devre dışı bırakıldı.",
      "mcpUnavailable": "Hermes udacapi MCP araçları göremez. CT253'te MCP'yi kaydedin (grant-udacapi-mcp.sh) ve relay :8101 → backend :8100'ı doğrulayın. runbooks/hermes-udacapi-agent-integration.md'yi görün."
    },
    "quota": {
      "exceededTitle": {
        "monthly": {
          "requests": "Aylık istek limitine ulaşıldı",
          "tokens": "Aylık token limitine ulaşıldı"
        },
        "five_hour": {
          "requests": "5 saatlik istek limitine ulaşıldı",
          "tokens": "5 saatlik token limitine ulaşıldı"
        },
        "weekly": {
          "requests": "Haftalık istek limitine ulaşıldı",
          "tokens": "Haftalık token limitine ulaşıldı"
        }
      },
      "usageLine": "{used} / {limit} kullanıldı",
      "resetsAt": "{relative} sonra tekrar kullanılabilir ({absolute})",
      "resetsUnknown": "Daha sonra tekrar deneyin veya limitleri artırmak için yöneticinize başvurun.",
      "viewSubscription": "Kota ayrıntılarını görüntüle",
      "sendBlocked": "Agent kotası tükendi — limitin sıfırlanmasını bekleyin.",
      "nearLimit": "Agent kotası neredeyse tükendi ({pct}%)."
    },
    "upgrade": {
      "lockedTitle": "Özellik kilitli",
      "lockedDescription": "\"{feature}\" {tier} planı ve üzerinde mevcuttur."
    },
    "subscription": {
      "sectionTitle": "Yapay Zekâ Ajanı",
      "sectionDescription": "Organizasyonunuzun ajan seviyesi, kotaları ve etkin özellikleri.",
      "currentTier": "Mevcut seviye",
      "active": "Aktif",
      "inactive": "Pasif",
      "features": "Etkin özellikler",
      "tier": "Seviye",
      "capabilities": "Özellikler",
      "billingPeriod": "Faturalama dönemi başlangıcı",
      "requests": "Bu dönem istekler",
      "requests_5h": "İstekler (son 5 saat)",
      "requests_weekly": "İstekler (son hafta)",
      "requests_badge": "ist.",
      "requests_5h_badge": "ist. (5s)",
      "requests_weekly_badge": "ist. (hafta)",
      "tokens": "Bu dönem tokenler",
      "tokens_5h": "Tokenler (son 5 saat)",
      "tokens_weekly": "Tokenler (son hafta)",
      "nearQuotaTitle": "Kota yakınında",
      "nearQuotaDescription": "Aylık kota %80'i kullanıldı. Limitleri artırmak için yöneticinize başvurun.",
      "tiers": {
        "free": "Ücretsiz",
        "pro": "Pro",
        "enterprise": "Kurumsal"
      },
      "trialActive": "Pro trial active until {date}. After that you stay on Free with plan limits.",
      "submissionsSoftExceeded": "Submission volume is above your plan soft limit. Contact us to upgrade — field sync is not blocked."
    },
    "report": {
      "title": "AI raporu PM için",
      "description": "Gönderim özeti UDA AI ajan tarafından hazırlandı.",
      "period": "Dönem (gün)",
      "generate": "Rapor oluştur",
      "generating": "Ajan rapor hazırlıyor...",
      "empty": "Rapor oluştur'a tıklayarak özeti alın.",
      "modeSummary": "Özet",
      "modeAnalytical": "Analitik",
      "quotaExceeded": "Agent kota aşıldı.",
      "featureUnavailable": "AI raporları planınızda mevcut değil.",
      "error": "Agent raporu alınamadı.",
      "healthAlerts": "Form sağlık notları",
      "copy": "Rapor kopyala",
      "copied": "Kopyalandı",
      "copyFailed": "Kopyalanamadı.",
      "viewFormatted": "Biçimlendirilmiş",
      "viewRaw": "Markdown",
      "modeScheduled": "Zamanlanmış",
      "auto": {
        "latest": "En son",
        "history": "Geçmiş",
        "generateNow": "Şimdi oluştur",
        "manageTemplates": "Şablonları yönet",
        "selectTemplate": "Şablon",
        "latestEmpty": "Henüz tamamlanmış şablon raporu yok. Bir şablon seçin ve Şimdi oluştur'a tıklayın.",
        "historyEmpty": "Henüz rapor çalıştırması yok.",
        "view": "Görüntüle",
        "viewTitle": "Rapor",
        "close": "Kapat",
        "generating": "Zamanlanmış rapor oluşturuluyor...",
        "done": "Rapor hazır.",
        "statusLabel": "Durum: {status}",
        "emptyResult": "Rapor tamamlandı ancak içerik döndürmedi.",
        "runFailed": "Rapor oluşturma başarısız.",
        "timeout": "Rapor çok uzun sürdü. Daha sonra tekrar deneyin.",
        "noContent": "Rapor içeriği mevcut değil.",
        "unknownTemplate": "Bilinmeyen şablon",
        "trigger": {
          "scheduled": "Zamanlanmış",
          "event": "Olay",
          "manual": "Manuel"
        },
        "status": {
          "pending": "Beklemede",
          "running": "Çalışıyor",
          "done": "Tamamlandı",
          "failed": "Başarısız"
        }
      },
      "templates": {
        "title": "Rapor şablonları",
        "subtitle": "Bu kuruluş için zamanlanmış ve isteğe bağlı yapay zekâ rapor istemlerini yapılandırın.",
        "create": "Yeni şablon",
        "createTitle": "Rapor şablonu oluştur",
        "edit": "Düzenle",
        "editTitle": "Rapor şablonunu düzenle",
        "formSubtitle": "Raporun kapsamını, ne zaman çalışacağını ve kimin alacağını tanımlayın.",
        "sections": {
          "content": "Rapor içeriği",
          "schedule": "Zamanlama",
          "delivery": "Teslimat ve kapsam"
        },
        "seed": "Varsayılanları yükle",
        "seeded": "{count} şablon yüklendi.",
        "empty": "Henüz şablon yok. Varsayılanları yükleyin veya bir tane oluşturun.",
        "active": "Aktif",
        "inactive": "Pasif",
        "cron": "Zamanlama",
        "sendByEmail": "E-posta ile gönder",
        "deactivate": "Devre dışı bırak",
        "deactivated": "Şablon devre dışı bırakıldı.",
        "activate": "Etkinleştir",
        "activated": "Şablon etkinleştirildi.",
        "save": "Kaydet",
        "saved": "Şablon kaydedildi.",
        "saveError": "Şablon kaydedilemedi.",
        "loadError": "Rapor şablonları yüklenemedi.",
        "validationRequired": "Ad ve istem zorunludur.",
        "recipientsPlaceholder": "Kuruluş üyelerini seçin",
        "recipientsRequired": "E-posta etkinleştirildiğinde en az bir alıcı seçin.",
        "promptHint": "Kuruluş verilerine, seçili formlara ve raporlama dönemine erişim otomatik eklenir.",
        "allFormsPlaceholder": "Tüm formlar (boş bırakın)",
        "advancedMode": "Özel istem (gelişmiş, Jinja2)",
        "fields": {
          "name": "Ad",
          "audience": "Hedef kitle",
          "prompt": "Rapor talimatları",
          "responseLanguage": "Yanıt dili",
          "recipients": "Alıcılar",
          "formScope": "Formlar"
        },
        "schedule": {
          "label": "Zamanlama",
          "none": "Zamanlama yok",
          "daily": "Günlük",
          "weekly": "Haftalık",
          "monthly": "Aylık",
          "custom": "Özel (cron)",
          "time": "Saat",
          "weekday": "Haftanın günü",
          "dayOfMonth": "Ayın günü",
          "customCron": "Cron ifadesi",
          "humanDaily": "Her gün {time}",
          "humanWeekly": "Her {weekday} {time}",
          "humanMonthly": "Her ayın {day}. günü {time}",
          "weekdays": {
            "0": "Pazar",
            "1": "Pazartesi",
            "2": "Salı",
            "3": "Çarşamba",
            "4": "Perşembe",
            "5": "Cuma",
            "6": "Cumartesi"
          }
        },
        "audience": {
          "pm": "Proje yöneticisi",
          "field_coord": "Saha koordinatörü",
          "statistician": "İstatistikçi",
          "executive": "Yönetici"
        }
      }
    },
    "chat": {
      "modeAsk": "Agent'a soru sor",
      "description": "Bu formun şeması, gönderimleri, analitikleri, QC kuralları ve senkronizasyon durumuyla ilgili sorular sorun. Cevaplar canlı veriler üzerinden oluşturulur; örnek gönderimler kişisel alanlar içerebilir.",
      "question": "Sorunuz",
      "placeholder": "e.g. Son 7 günde kaç gönderim var? Bu formda hangi alanlar var?",
      "send": "Gönder",
      "empty": "Bu formun verileriyle ilgili bir soru sorun.",
      "you": "Sen",
      "agent": "Ajan",
      "generating": "Agent form verilerini arıyor...",
      "sendHint": "Enter — gönder · Shift+Enter — yeni satır"
    },
    "analytical": {
      "generate": "Analitik rapor çalıştır",
      "empty": "Derin form analizi için analitik rapor çalıştırın.",
      "queued": "Rapor bekliyor...",
      "status": "Durum: {status}",
      "done": "Rapor hazır.",
      "failed": "Analitik rapor oluşturulamadı.",
      "emptyResult": "Rapor tamamlandı ancak içerik döndürmedi.",
      "timeout": "Analitik rapor çok uzun sürdü. Agent rapor çalışanı çalışıyor mu kontrol edin.",
      "workerHint": "İş hala bekliyor. Agent rapor çalışanı hizmetini (docker compose up -d agent-reports-worker) başlatın ve tekrar deneyin."
    },
    "qc": {
      "title": "AI QC asistan",
      "description": "Bir denetimi basit bir dil ile açıklayın — agent QC kuralı taslayacaktır.",
      "checkDescription": "Denetim açıklaması",
      "checkPlaceholder": "e.g. yanıtlayıcı yaşı 18-65 arasında olmalıdır",
      "suggest": "Kural öner",
      "generating": "Agent kural taslıyor...",
      "applyDraft": "Taslak formu uygula",
      "draftApplied": "Taslak formu uygulandı.",
      "draftPreview": "Önerilen kural",
      "viewRawResponse": "Agent cevabını tam görüntüle",
      "sendHint": "Enter — öner · Shift+Enter — yeni satır",
      "noDraftParsed": "Agent cevabından bir kural taslak JSON ayrılamadı.",
      "validationWarnings": "Doğrulama notları ({count}):",
      "starterPack": {
        "title": "Başlangıç QC kuralları",
        "description": "Formu gözden geçirin ve doğrulama için önerilen kuralları alın.",
        "focus": "Odak",
        "focusAll": "Dengeli karışım",
        "focusRequired": "Zorunlu alanlar sadece",
        "focusConstraints": "Kısıtlamalar sadece",
        "maxRules": "Max kurallar",
        "suggest": "Başlangıç kuralları öner",
        "generating": "Formu gözden geçirin ve kuralları taslıyor...",
        "apply": "Bu kuralı uygula",
        "empty": "Geçerli bir kural taslak döndürmedi. Tekrar deneyin veya tek kural önerisini kullanın.",
        "skippedHint": "{count} önerilen kural(lar) atlandı (yinelenen, geçersiz, veya sınır aşıldı)."
      }
    },
    "xlsform": {
      "openButton": "AI XLSForm",
      "title": "AI XLSForm asistan",
      "description": "Sorular dosyası yükleyin veya görev açıklayın — agent taslak, test ve yayın onayı isteyecektir.",
      "instruction": "Agent için talimat",
      "instructionPlaceholder": "e.g. 5 soruluk memnuniyet anketi formu oluştur",
      "empty": "Bu formu ne istiyorsanız veya dosya yükleyin — agent taslak ve test edecektir.",
      "send": "Gönder",
      "sendHint": "Enter — gönder · Shift+Enter — yeni satır",
      "working": "Agent görev üzerinde çalışıyor...",
      "you": "Sen",
      "agent": "Ajan",
      "publishTitle": "Yayın onayı",
      "publishDescription": "Agent bir taslak yayınlamayı istedi. Manuel olarak onaylayın — yayın onayı olmadan devam edemez.",
      "formId": "Form ID (xmlFormId)",
      "versionOptional": "Sürüm (isteğe bağlı)",
      "confirmPublish": "Yayın onayı",
      "upload": {
        "hint": "Sorularınızı Excel/CSV, Word veya metin ile ekleyin (max 5 MB)",
        "attachAria": "Dosya ekle",
        "removeAttachment": "Eki kaldır",
        "selected": "Dosya: {name}",
        "attachmentPrefix": "[dosya: {name}]"
      },
      "session": {
        "resumeBanner": "Devam eden AI XLSForm oturumu (taslak: {formId})",
        "resumeButton": "Devam et",
        "startNewButton": "Yeniden başla",
        "dismissButton": "Kapat",
        "dismissError": "Oturum kapatılamadı. Tekrar deneyin.",
        "historyButton": "Önceki oturumlar",
        "historyTitle": "AI XLSForm oturumları",
        "historyHint": "Son 7 günün oturumları. Taslağa devam edin veya yayınlanmış oturumu görüntüleyin.",
        "historyEmpty": "Bu proje için önceki oturum yok.",
        "historyFormColumn": "Taslak",
        "historyStatusColumn": "Durum",
        "historyUpdatedColumn": "Güncellendi",
        "historyMessagesColumn": "Mesajlar",
        "historyActionsColumn": "İşlemler",
        "continueButton": "Devam et",
        "viewButton": "Görüntüle",
        "continueError": "Oturum devam ettirilemedi. Tekrar deneyin.",
        "readOnlyHint": "Bu oturum yayınlandı. Sohbet geçmişini görüntüleyebilirsiniz ancak yeni mesaj gönderemezsiniz.",
        "draftUnknown": "isimsiz",
        "status": {
          "active": "Aktif",
          "discarded": "Kapatıldı",
          "failed": "Başarısız",
          "published": "Yayınlandı"
        },
        "historyAriaLabel": "Oturum geçmişi",
        "historyPreviewColumn": "Son not",
        "clearDismissedButton": "Kapatılanları temizle",
        "clearFailedButton": "Başarısızları temizle",
        "clearNonPublishedButton": "Yayınlanmayanları temizle",
        "cleanupError": "Önceki oturumlar temizlenemedi. Tekrar deneyin.",
        "forkedFrom": "Önceki sürümden çatallandı",
        "lineagePublished": "Yayınlanan sürüm",
        "cleanupConfirm": {
          "dismissed": {
            "title": "Kapatılan oturumlar temizlensin mi?",
            "message": "Bu, bu proje için kapatılan oturumları kalıcı olarak siler. Yayınlanan oturumlar korunur."
          },
          "failed": {
            "title": "Başarısız oturumlar temizlensin mi?",
            "message": "Bu, bu proje için başarısız oturumları kalıcı olarak siler."
          },
          "non_published": {
            "title": "Yayınlanmayan tüm oturumlar temizlensin mi?",
            "message": "Bu, aktif, kapatılan ve başarısız oturumları kalıcı olarak siler. Yayınlanan oturumlar korunur."
          }
        }
      },
      "job": {
        "canClose": "Bu pencereyi kapatabilirsiniz — oturumunuz arka planda devam edecektir.",
        "elapsed": "Çalışıyor… {time}",
        "agentWorking": "Agent isteğinizi işliyor (LLM ve MCP araçları). Bu adım birkaç dakika sürebilir.",
        "longWait": "Hala çalışıyor — LLM proxy ve Hermes MCP relay sağlıklı mı kontrol edin eğer bu 10 dakikadan daha uzun sürerse.",
        "timeout": "Form asistanı zamanında bitmedi. Başarısız oturum sıfırlandı; yeni bir oturumda tekrar deneyin.",
        "failed": "Form asistanı başarısız oldu. Tekrar deneyin.",
        "phases": {
          "queued": "Bekliyor",
          "planning": "İstek analizi",
          "editing": "Form sorularını düzenleme",
          "uploading_draft": "Taslak form oluşturma",
          "testing_draft": "Taslak testi",
          "finalizing": "Cevap hazırlama",
          "completed": "Tamamlandı"
        },
        "queuedFallback": "Çalışan henüz işi almadı — sunucu yakında işlemde tekrar deneyecektir."
      },
      "preview": {
        "tabChat": "Sohbet",
        "tabPreview": "Önizleme",
        "loading": "Form önizleme yükleniyor…",
        "empty": "Henüz taslak önizleme yok. Asistanın formu oluşturmasını veya düzenlemesini isteyin.",
        "error": "Form önizleme yüklenemedi.",
        "submitError": "Test gönderimi gönderilemedi."
      },
      "workbench": {
        "tabChat": "Sohbet",
        "tabPreview": "Önizleme",
        "downloadDraft": "Taslağı indir",
        "downloadPublished": "Yayınlananı indir",
        "uploadExcel": "Excel yükle",
        "uploadConfirmTitle": "Form Excel ile değiştirilsin mi?",
        "uploadConfirmMessage": "Bu, mevcut taslak soruları yüklenen elektronik tablo ile değiştirir.",
        "uploadConfirmDetail": "Asistan oturum geçmişi korunur; yalnızca form yapısı değişir.",
        "startRevision": "Revizyonu başlat",
        "openForm": "Projede formu aç",
        "downloadError": "Excel dosyası indirilemedi.",
        "importError": "Excel dosyası içe aktarılamadı.",
        "forkError": "Revizyon oturumu başlatılamadı."
      },
      "settings": {
        "title": "Form ayarları",
        "hint": "Form ID, ODK xmlFormId olur. Bu projede benzersiz olmalıdır. Yayınladıktan sonra değiştirmekten kaçının.",
        "formTitle": "Form başlığı",
        "formId": "Form ID (xmlFormId)",
        "save": "Ayarları kaydet",
        "saved": "Ayarlar kaydedildi",
        "conflict": "Bu Form ID projede zaten kullanılıyor.",
        "suggestion": "Deneyin: {id}",
        "saveError": "Form ayarları kaydedilemedi.",
        "saveBusy": "Ajan işi taslağı tutarken kaydedilemedi. İşin bitmesini bekleyin veya tekrar deneyin."
      },
      "header": {
        "newForm": "Yeni form",
        "version": "Spec v{version}",
        "status": {
          "idea": "Planlama",
          "draft": "Taslak hazır",
          "publish": "Yayın bekleniyor",
          "published": "Yayınlandı",
          "conflict": "Dikkat gerektiriyor",
          "failed": "Başarısız"
        }
      },
      "timeline": {
        "title": "Sistem olayları"
      },
      "changes": {
        "title": "Değişiklik özeti"
      },
      "validation": {
        "title": "Doğrulama",
        "empty": "Doğrulama, ilk taslak güncellemesinden sonra görünecek.",
        "noIssues": "Engelleyici sorun tespit edilmedi.",
        "applySuggestedId": "Önerilen ID'yi uygula",
        "editSettings": "Ayarları düzenle",
        "status": {
          "ok": "Tamam",
          "warning": "Uyarı",
          "error": "Hata"
        }
      },
      "recovery": {
        "retryLast": "Son isteği tekrar dene",
        "startFresh": "Yeni oturum başlat"
      }
    },
    "entitlement": {
      "title": "Upgrade required",
      "body": "This capability is not included in your current organization plan. Contact us to upgrade to Pro or Enterprise.",
      "contactUs": "Contact us to upgrade your plan."
    }
  },
  "websocket": {
    "notifications": {
      "syncComplete": "Eşitleme tamamlandı: {formName}. {total} kayıttan {count} işlendi",
      "syncError": "Eşitleme hatası: {formName}. {error}",
      "formStatusChange": "Form durumu değişti: {formName} ({oldStatus} → {newStatus})",
      "schedulerUpdate": "Zamanlayıcı: {status}. Aktif işler: {activeJobs}/{totalJobs}",
      "qcValidationComplete": "QC doğrulaması tamamlandı: {instanceId}. Kurallar: {totalRules}, geçen: {passedRules}, hatalar: {errorRules}, uyarılar: {warningRules}",
      "projectStatusSummary": "Kritik değişiklikler: {totalProjects} proje ve {totalForms} formdan {errorProjects} projede, {errorForms} formda hata var"
    },
    "connection": {
      "connected": "WebSocket bağlandı",
      "disconnected": "WebSocket bağlantısı kesildi",
      "reconnecting": "Yeniden bağlanılıyor...",
      "error": "WebSocket hatası: {error}",
      "maxRetriesReached": "Maksimum yeniden bağlanma denemesine ulaşıldı"
    },
    "connected": "Bağlı",
    "disconnected": "Bağlantı kesildi",
    "realTimeUpdates": "Anlık güncellemeler"
  },
  "buttonSelect": {
    "dark": "Koyu",
    "light": "Açık"
  },
  "odkOptions": {
    "themes": {
      "light": "Açık",
      "dark": "Koyu"
    },
    "navigation": {
      "swipe": "Kaydırma",
      "buttons": "Düğmeler",
      "swipe_buttons": "Kaydırma + Düğmeler"
    },
    "formUpdate": {
      "manual": "Manuel",
      "previously_downloaded": "Önceden indirilmiş",
      "match_exactly": "Tam eşleşme"
    },
    "periodicUpdates": {
      "every_fifteen_minutes": "Her 15 dakikada",
      "every_one_hour": "Her 1 saatte",
      "every_six_hours": "Her 6 saatte",
      "every_24_hours": "Her 24 saatte"
    },
    "autosend": {
      "off": "Kapalı",
      "wifi_only": "Yalnızca Wi‑Fi",
      "cellular_only": "Yalnızca mobil veri",
      "wifi_and_cellular": "Wi‑Fi ve mobil veri"
    },
    "constraintBehavior": {
      "on_swipe": "Kaydırmada",
      "on_finalize": "Sonlandırmada"
    },
    "imageSizes": {
      "original": "Orijinal",
      "very_small": "Çok küçük",
      "small": "Küçük",
      "medium": "Orta",
      "large": "Büyük"
    },
    "guidanceHint": {
      "no": "Hayır",
      "yes": "Evet",
      "yes_collapsed": "Evet (daraltılmış)"
    },
    "basemap": {
      "google": "Google",
      "mapbox": "Mapbox",
      "osm": "OSM",
      "usgs": "USGS",
      "carto": "Carto"
    },
    "mapStyles": {
      "normal": "Normal",
      "terrain": "Arazi",
      "hybrid": "Hibrit",
      "satellite": "Uydu",
      "light": "Açık",
      "dark": "Koyu",
      "satellite_streets": "Uydu + sokaklar",
      "outdoors": "Açık hava",
      "topographic": "Topoğrafik",
      "positron": "Positron",
      "dark_matter": "Karanlık madde"
    },
    "fontSizes": {
      "small": "Küçük",
      "normal": "Normal",
      "large": "Büyük",
      "xl": "XL",
      "xxl": "XXL"
    }
  },
  "users": {
    "title": "Kullanıcı Yönetimi",
    "subtitle": "Organizasyon üyelerini yönetin, etkinliğe göre filtreleyin ve erişim kayıtlarını güncelleyin.",
    "searchUser": "Kullanıcı ara",
    "addUser": "Kullanıcı ekle",
    "editUser": "Kullanıcıyı düzenle",
    "deleteUser": "Kullanıcıyı sil",
    "firstName": "Ad",
    "lastName": "Soyad",
    "fullName": "Ad soyad",
    "email": "E-posta",
    "password": "Parola",
    "confirmPassword": "Parolayı onayla",
    "enterEmail": "E-posta girin",
    "userCreated": "Kullanıcı başarıyla oluşturuldu",
    "userUpdated": "Kullanıcı başarıyla güncellendi",
    "userDeleted": "Kullanıcı başarıyla silindi",
    "confirmDeleteUser": "Bu kullanıcıyı silmek istediğinizden emin misiniz?",
    "projectSelection": {
      "archived": "Arşivlenmiş",
      "noProjects": "Kullanılabilir proje yok",
      "noProjectsDescription": "Atama için kullanılabilir proje yok",
      "errorLoadingProjects": "Projeler yüklenirken hata"
    },
    "admin": "Yönetici",
    "data_collector": "Veri Toplayıcı",
    "supervisor": "Denetçi",
    "user": "Kullanıcı",
    "owner": "Sahip",
    "isClient": "İstemci",
    "active": "Aktif",
    "inactive": "Pasif",
    "refresh": "Yenile",
    "unsavedChanges": "Formda kaydedilmemiş değişiklikler var. Kapatmak istediğinizden emin misiniz?",
    "validation": {
      "passwordRequired": "Parola gerekli",
      "passwordMinLength": "Parola en az 8 karakter olmalı",
      "confirmPasswordRequired": "Lütfen parolayı onaylayın",
      "passwordsDontMatch": "Parolalar eşleşmiyor"
    },
    "editUserDescription": "Kullanıcı bilgilerini güncelle",
    "addUserDescription": "Sistemde yeni kullanıcı oluştur",
    "basicInformation": "Temel Bilgiler",
    "fullNamePlaceholder": "Ad soyad girin",
    "passwordSettings": "Parola Ayarları",
    "passwordPlaceholder": "Parola girin",
    "confirmPasswordPlaceholder": "Parolayı onaylayın",
    "passwordHelp": "Parola en az 8 karakter olmalı",
    "userSettings": "Kullanıcı Ayarları",
    "clientUserDescription": "İstemci kullanıcısının sınırlı erişimi vardır",
    "inactiveUserDescription": "Pasif kullanıcılar sisteme giriş yapamaz",
    "noName": "Adı yok"
  },
  "user": {
    "system": "Sistem",
    "account": "Hesap",
    "explore": "Keşfet",
    "profile": "Profil",
    "logout": "Çıkış",
    "settings": "Ayarlar",
    "projects": "Projeler",
    "faq": "Yardım",
    "helpAndSupport": "Yardım ve destek",
    "administration": "Yönetim",
    "help": "Yardım"
  },
  "odkSync": {
    "dashboard": {
      "title": "ODK Eşitleme Paneli"
    },
    "workbench": {
      "contextHint": "ODK sunucularından veri alımını izleyin ve kurulum imleçlerini tüm kuruluşunuzda yönetin.",
      "live": "Canlı güncellemeler",
      "reconnect": "Yeniden bağlan",
      "loading": "Eşitleme verileri yükleniyor…",
      "schedulerPill": "Zamanlayıcı",
      "schedulerActive": "Aktif",
      "schedulerPaused": "Duraklatıldı",
      "schedulerStopped": "Durduruldu",
      "statusLive": "Canlı",
      "statusOffline": "Bağlantı kesildi",
      "statusSchedulerActive": "Aktif",
      "statusSchedulerPaused": "Duraklatıldı",
      "statusSchedulerStopped": "Durduruldu",
      "createShort": "Yeni",
      "pipeline": {
        "ariaLabel": "Eşitleme pipeline durumu",
        "scheduler": "Zamanlayıcı",
        "schedulerActive": "Programa göre çalışıyor",
        "schedulerPaused": "Duraklatıldı — gönderimler eşitlenmiyor",
        "pull": "Son çekme",
        "cursors": "Kurulum imleçleri",
        "cursorsHint": "{count} form takip ediliyor",
        "cursorsEmpty": "Henüz kurulum imleci yok"
      }
    },
    "table": {
      "emptyState": "Henüz kurulum imleci yok. Gönderimleri çekmeye başlamak için bir kurulum imleci oluşturun."
    },
    "scheduler": {
      "title": "Eşitleme Zamanlayıcı",
      "pauseScheduler": "Zamanlayıcıyı Duraklat",
      "resumeScheduler": "Zamanlayıcıyı Sürdür",
      "pausedMessage": "ODK veri eşitlemesi şu an duraklatıldı. Devam ettirilene kadar yeni gönderimler eşitlenmeyecek."
    },
    "managerScope": {
      "title": "Eşitleme verilerini görüntüleme",
      "message": "Yönettiğiniz {count} proje için eşitleme verilerini görüntülüyorsunuz. Yalnızca yönetici rolüne sahip olduğunuz projelerin eşitlemesini görebilir ve kontrol edebilirsiniz."
    },
    "statistics": {
      "title": "Eşitleme İstatistikleri",
      "totalCursors": "Toplam İmleç",
      "lastSync": "Son Eşitleme"
    },
    "cursors": {
      "title": "Eşitleme İmleçleri",
      "viewModes": {
        "cards": "Kartlar",
        "table": "Tablo",
        "projects": "Projelere Göre",
        "list": "Liste"
      },
      "actions": {
        "clear": "Temizle",
        "bulkSync": "Toplu Eşitle ({count})",
        "bulkReset": "Toplu Sıfırla ({count})",
        "createCursor": "İmleç Oluştur"
      }
    },
    "auto": {
      "managed": "Otomatik",
      "manual": "Manuel",
      "enableAuto": "Otomatik Aç ({count})",
      "disableAuto": "Otomatik Kapat ({count})",
      "reason": "Neden",
      "reasons": {
        "importedActive": "İçe aktarılan aktif form",
        "createdActive": "Oluşturulan aktif form",
        "uploadedActive": "Yüklenen aktif form",
        "formOpened": "Form açıldı",
        "formClosed": "Form kapatıldı",
        "formReopened": "Form yeniden açıldı",
        "newFormOpened": "Yeni form açıldı",
        "migrated": "Taşındı",
        "formNotFound": "Form bulunamadı",
        "manualOverride": "Manuel geçersiz kılma",
        "formDeleted": "Form silindi",
        "importedFormDeleted": "İçe aktarılan form silindi"
      }
    },
    "projectSummary": {
      "forms": "Formlar: {count}",
      "lastSync": "Son Eşitleme",
      "active": "Aktif: {count}",
      "errors": "Hatalar: {count}",
      "inactive": "Pasif: {count}",
      "noProjects": "Proje Yok",
      "createFirstCursor": "İlk eşitleme imlecinizi oluşturun"
    },
    "projectResponsible": {
      "responsible": "Sorumlu",
      "notAssigned": "Atanmamış",
      "assign": "Ata",
      "remove": "Kaldır",
      "assignModal": {
        "title": "\"{project}\" projesi için sorumlu ata",
        "selectUser": "Kullanıcı seçin",
        "selectUserPlaceholder": "Sorumlu kişi seçin",
        "assign": "Ata",
        "noUsers": "Kullanılabilir kullanıcı yok",
        "noUsersMessage": "Proje sorumlusu olarak atanacak kuruluşta kullanıcı yok."
      }
    },
    "modals": {
      "createCursor": {
        "title": "Eşitleme İmleci Oluştur",
        "server": "Sunucu",
        "project": "Proje",
        "xmlForm": "XML Formu",
        "serverPlaceholder": "Sunucu seçin",
        "projectPlaceholder": "Proje seçin",
        "xmlFormPlaceholder": "Form seçin"
      },
      "manualSync": {
        "title": "Manuel Eşitleme",
        "selectCursors": "İmleçleri Seçin",
        "forceFullSync": "Tam Eşitlemeyi Zorla",
        "maxConcurrent": "Maks. Eşzamanlı Eşitleme",
        "startSync": "Eşitlemeyi Başlat"
      }
    },
    "messages": {
      "schedulerPaused": "ODK eşitleme zamanlayıcısı duraklatıldı",
      "schedulerResumed": "ODK eşitleme zamanlayıcısı sürdürüldü",
      "cursorCreated": "Eşitleme imleci başarıyla oluşturuldu",
      "manualSyncTriggered": "Manuel eşitleme başarıyla tetiklendi",
      "cursorReset": "İmleç başarıyla sıfırlandı",
      "bulkResetSuccess": "{count} imleç başarıyla sıfırlandı",
      "selectCursorsForSync": "Lütfen eşitleme için en az bir imleç seçin",
      "never": "Hiçbir zaman"
    },
    "errors": {
      "failedToLoadSyncData": "Eşitleme verileri yüklenemedi",
      "failedToControlScheduler": "Zamanlayıcı kontrol edilemedi",
      "failedToCreateCursor": "Eşitleme imleci oluşturulamadı",
      "failedToTriggerManualSync": "Manuel eşitleme tetiklenemedi",
      "failedToResetCursor": "İmleç sıfırlanamadı",
      "failedToResetSomeCursors": "Bazı imleçler sıfırlanamadı"
    },
    "filters": {
      "showAllForms": "Tüm imleçleri göster",
      "filteringTitle": "İmleç filtreleme",
      "filteringMessage": "{total} imleçten {filtered} gösteriliyor. {hidden} pasif imleç gizlendi."
    },
    "formStatus": {
      "title": "Form durumu ve optimizasyon",
      "checkStatuses": "Durumları kontrol et",
      "statusLabels": {
        "open": "Açık",
        "closing": "Kapanıyor",
        "closed": "Kapalı",
        "unknown": "Bilinmiyor"
      },
      "cards": {
        "title": "Form durumu",
        "description": "İmleçleri kontrol edin ve optimize edin",
        "refresh": "Yenile"
      },
      "loading": "Yükleniyor...",
      "autoCheckInterval": "5 dakika",
      "lastCheck": "Otomatik her 5 dakikada",
      "benefits": {
        "autoDisable": "Kapalı formlar için otomatik imleç devre dışı bırakma",
        "resourceOptimization": "Eşitleme kaynak optimizasyonu",
        "performanceImprovement": "Geliştirilmiş performans"
      },
      "messages": {
        "checkStarted": "Form durumu kontrolü başladı",
        "checkError": "Form durumları kontrol edilirken hata",
        "enableError": "İmleçler etkinleştirilirken hata",
        "disableError": "İmleçler devre dışı bırakılırken hata"
      }
    }
  },
  "odkQc": {
    "dashboard": {
      "title": "QC Paneli - ODK Veri Kalitesi",
      "description": "Doğrulama kuralları kullanarak ODK gönderim verilerinin kalitesini izleme"
    },
    "statistics": {
      "totalRules": "Toplam Kural",
      "activeRules": "Aktif Kurallar",
      "inactiveRules": "Pasif Kurallar",
      "recentValidations": "Son Doğrulamalar"
    },
    "sections": {
      "rulesByType": "Türe Göre Kurallar",
      "rulesBySeverity": "Önem Derecesine Göre Kurallar",
      "qcRules": "QC Kuralları"
    },
    "filters": {
      "allTypes": "Tüm Türler",
      "allLevels": "Tüm Seviyeler",
      "allStatuses": "Tüm Durumlar",
      "active": "Aktif",
      "inactive": "Pasif"
    },
    "actions": {
      "createRule": "Kural Oluştur",
      "activate": "Etkinleştir",
      "deactivate": "Devre Dışı Bırak",
      "clearSelection": "Seçimi Temizle"
    },
    "ruleTypes": {
      "required": "Zorunlu",
      "constraint": "Kısıt",
      "calculation": "Hesaplama",
      "custom": "Özel"
    },
    "severityLevels": {
      "error": "Hata",
      "warning": "Uyarı",
      "info": "Bilgi"
    },
    "messages": {
      "noRuleTypeData": "Kural türü verisi yok",
      "noSeverityData": "Önem derecesi verisi yok",
      "ruleUpdated": "Kural başarıyla güncellendi",
      "ruleCreated": "Kural başarıyla oluşturuldu",
      "ruleSaveError": "Kural kaydedilirken hata",
      "ruleLoadError": "Veri yüklenirken hata",
      "ruleStatusToggled": "{ruleName} kuralı durumu değişti",
      "ruleStatusError": "Kural durumu değiştirilirken hata",
      "confirmDeleteRule": "\"{ruleName}\" kuralı silinsin mi?",
      "ruleDeleted": "Kural başarıyla silindi",
      "ruleDeleteError": "Kural silinirken hata",
      "ruleSaved": "Kural başarıyla kaydedildi",
      "bulkStatusToggled": "{count} kuralın durumu değişti",
      "bulkStatusError": "Kuralların durumu değiştirilirken hata",
      "bulkDeleted": "{count} kural silindi",
      "bulkDeleteError": "Kurallar silinirken hata",
      "rulesDeleted": "Kurallar silindi",
      "rulesActivated": "Kurallar etkinleştirildi",
      "rulesDeactivated": "Kurallar devre dışı bırakıldı",
      "ruleNotFound": "Kural bulunamadı",
      "invalidJsonFormat": "Geçersiz JSON biçimi",
      "createExpressionFirst": "Önce ifade oluşturun",
      "previewError": "Önizleme sırasında hata",
      "invalidRuleExpression": "Geçersiz kural ifadesi",
      "ruleNotExecuted": "Kural çalıştırılmadı",
      "loadingRule": "Kural yükleniyor...",
      "saving": "Kaydediliyor...",
      "loading": "Yükleniyor...",
      "run": "Çalıştır",
      "passed": "Geçti",
      "failed": "Başarısız",
      "success": "Başarılı",
      "errorDuringValidation": "Doğrulama sırasında hata",
      "noQcRulesFound": "QC kuralı bulunamadı"
    },
    "form": {
      "ruleName": "Kural Adı",
      "ruleNameRequired": "Kural adı gerekli",
      "fieldPath": "Birincil Alan",
      "fieldPathRequired": "Birincil alan gerekli",
      "fieldPathHint": "Bu kuralın doğruladığı ana alan. Diğer alanlar JSONLogic ifadesinde kullanılabilir.",
      "errorMessage": "Hata Mesajı",
      "errorMessageHint": "Gözden geçirenler için gösterilirken hata mesajı.",
      "errorMessageRequired": "Hata mesajı gerekli",
      "constraintExpression": "Kısıt İfadesi",
      "constraintExpressionHint": "Gönderim alanlarını referans almak için '{'\"var\": \"field_name\"'}' kullanın. JSON doğrulamak için Uygula'ya tıklayın.",
      "constraintExpressionRequired": "Kısıt ifadesi gerekli",
      "ruleType": "Kural Türü",
      "severityLevel": "Önem Derecesi",
      "ruleActive": "Kural aktif",
      "ruleActiveHint": "Pasif kurallar tutulur ama doğrulama sırasında uygulanmaz.",
      "basicSettings": "Temel Ayarlar",
      "jsonLogicBuilder": "JSONLogic Oluşturucu",
      "jsonLogicBuilderHint": "Bu kuralın geçtiği zamanı tanımlar. İfade doğruysa geçerli gönderimler için değerlendirilir.",
      "reset": "Sıfırla",
      "apply": "Uygula",
      "saveChanges": "Değişiklikleri Kaydet",
      "createRule": "Kural Oluştur",
      "editRule": "Kuralı Düzenle",
      "rulePreview": "Kural Önizlemesi",
      "testRuleOnSample": "Örnek veride kuralı test et",
      "detailedResults": "Ayrıntılı Sonuçlar",
      "showSubmissionData": "Gönderim verilerini göster",
      "help": "Yardım",
      "ruleTypes": "Kural Türleri",
      "severityLevels": "Önem Dereceleri",
      "requiredField": "Zorunlu alan",
      "constraintCheck": "Kısıt kontrolü",
      "calculatedField": "Hesaplanan alan",
      "customLogic": "Özel mantık",
      "blocksSubmission": "Gönderimi engeller",
      "showsWarning": "Uyarı gösterir",
      "informationalMessage": "Bilgilendirme mesajı",
      "jsonLogicExamplesTitle": "hh_question için JSONLogic ifade örnekleri:",
      "agreementCheckExample": "Anlaşma kontrolü:",
      "finalStatusCheckExample": "Son durum kontrolü:",
      "enumeratorCheckExample": "Sayıcı kontrolü:",
      "complexLogicExample": "Karmaşık mantık:",
      "fieldValue": "Alan değeri",
      "previewStatsLine": "{passed} geçti · {failed} başarısız · {rate}%"
    },
    "placeholders": {
      "searchByNameFieldMessage": "Ad, alan veya mesaja göre ara...",
      "ruleType": "Kural türü",
      "severityLevel": "Önem derecesi",
      "status": "Durum",
      "enterRuleName": "Kural adı girin",
      "enterErrorMessage": "Hata mesajı girin",
      "respondentAge": "respondent.age"
    },
    "table": {
      "ariaLabels": {
        "disableRule": "Kuralı devre dışı bırak",
        "enableRule": "Kuralı etkinleştir"
      }
    },
    "viewModes": {
      "cards": "Kartlar",
      "table": "Tablo"
    }
  },
  "odkCleanup": {
    "page": {
      "title": "ODK Veri Temizleme Monitörü",
      "subtitle": "Otomatik temizleme sistemini izleyin ve veri istatistiklerini görüntüleyin",
      "selectFormTitle": "Temizleme İzleme için Form Seçin",
      "currentProject": "Mevcut Proje",
      "searchPlaceholder": "Form ara ve seç...",
      "systemInfo": {
        "title": "Otomatik Temizleme Sistemi",
        "activeFormsTitle": "Aktif formlar (açık/kapanıyor)",
        "activeFormsDesc": "Yalnızca en son 5 klasör otomatik olarak saklanır. Temizleme her senkronizasyon sırasında gerçekleşir.",
        "closedFormsTitle": "Kapalı formlar (kapalı)",
        "closedFormsDesc": "Bir form kapatıldığında, 4 klasör otomatik olarak arşivlenir, 1 tanesi istatistikler için bırakılır.",
        "monitoringTitle": "İzleme",
        "monitoringDesc": "İstatistikleri görüntülemek ve temizleme sistemini izlemek için yukarıdan bir form seçin."
      }
    },
    "manager": {
      "title": "ODK Veri Temizleme Yöneticisi",
      "loading": "Temizleme verileri yükleniyor...",
      "noData": {
        "title": "Veri Mevcut Değil",
        "meaning": "Bu ne anlama geliyor:",
        "noSubmissions": "Bu formun henüz gönderimi yok",
        "noSync": "Form henüz ODK Central'dan senkronize edilmedi",
        "noCleanupNeeded": "Şu anda temizleme gerekmiyor"
      },
      "errorLoading": "Veri Yükleme Hatası",
      "stats": {
        "title": "Güncel İstatistikler",
        "totalFolders": "Toplam Klasör",
        "totalSize": "Toplam Boyut",
        "completeData": "Tam Veri"
      },
      "formInfo": {
        "title": "Form Bilgileri",
        "state": "Durum:",
        "active": "Aktif:",
        "lastSubmission": "Son Gönderim:",
        "lastSync": "Son Senkronizasyon:",
        "yes": "Evet",
        "no": "Hayır"
      },
      "recommendation": {
        "title": "Temizleme Önerisi",
        "action": "Eylem:",
        "reason": "Neden:",
        "requiresApproval": "Temizleme için onay gerekiyor"
      },
      "buttons": {
        "refresh": "İstatistikleri Yenile",
        "dryRun": "Deneme Çalıştırması",
        "cleanupNow": "Şimdi Temizle",
        "forceCleanup": "Temizlemeye Zorla"
      },
      "results": {
        "title": "Son Temizleme Sonucu",
        "strategy": "Strateji:",
        "kept": "Saklanan: {count} klasör",
        "deleted": "Silinen: {count} klasör",
        "archived": "Arşivlenen: {count} klasör",
        "skipped": "Atlanan: {count} klasör"
      },
      "folders": {
        "title": "Son Klasörler ({count})",
        "columns": {
          "name": "Klasör Adı",
          "created": "Oluşturuldu",
          "size": "Boyut (MB)",
          "files": "Dosyalar"
        }
      }
    },
    "messages": {
      "globalCleanupSuccess": "Genel temizleme başarıyla tamamlandı",
      "globalCleanupFailed": "Genel temizleme başarısız oldu",
      "errorLoadingProjects": "Projeler yüklenirken hata oluştu",
      "errorLoadingForms": "Formlar yüklenirken hata oluştu",
      "noDataOrSync": "Bu formun verisi yok veya henüz senkronize edilmedi",
      "statsLoadFailed": "Temizleme istatistikleri yüklenemedi",
      "dryRunSuccess": "Deneme çalıştırması tamamlandı - hiçbir dosya silinmedi",
      "dryRunFailed": "Deneme çalıştırması başarısız oldu",
      "cleanupNotRecommended": "Bu form için temizleme önerilmiyor",
      "cleanupSuccess": "Temizleme başarıyla tamamlandı",
      "cleanupFailed": "Temizleme başarısız oldu",
      "forceNotAvailable": "Bu form için zorunlu temizleme mevcut değil",
      "forceConfirm": "Temizlemeye zorlamak istediğinizden emin misiniz? Bu işlem geri alınamaz.",
      "forceSuccess": "Zorunlu temizleme başarıyla tamamlandı",
      "forceFailed": "Zorunlu temizleme başarısız oldu"
    }
  },
  "permissionGroups": {
    "create": "Grup Oluştur",
    "delete": "Grubu Sil",
    "assignToUser": "Grubu Kullanıcıya Ata",
    "removeFromUser": "Kullanıcıdan Grubu Kaldır",
    "roleNames": {
      "manager": "Yönetici",
      "projectMember": "Proje üyesi",
      "dataViewer": "Veri Görüntüleyici",
      "dataCollector": "Veri Toplayıcı",
      "dataDownloader": "Veri İndirici",
      "dataAnalyst": "Veri Analisti",
      "qcViewer": "QC Görüntüleyici",
      "qcEditor": "QC Düzenleyici",
      "monitor": "İzleyici",
      "formDesigner": "Form Tasarımcısı"
    },
    "userManagement": {
      "clientGroups": "İstemci Grupları",
      "regularGroups": "Normal Gruplar",
      "regularGroupsDescription": "Proje üyeleri için tasarlanmış gruplar.",
      "clientGroupsDescription": "Dış veya müşteriye yönelik kullanıcılar için tasarlanmış gruplar.",
      "errorTitle": "Gruplar yüklenemedi",
      "noProjectsTitle": "Önce bir proje seçin",
      "noProjectsDescription": "Grup atamak için önce bir proje seçin.",
      "noGroupsTitle": "Grup yok",
      "noGroupsAvailable": "Atama için uygun grup yok",
      "errorLoadingGroups": "Gruplar yüklenirken hata oluştu",
      "selectedGroups": "Seçilen gruplar",
      "selectedCount": "{count} seçildi",
      "selectedPill": "Seçildi",
      "includedPermissions": "Dahil edilen izinler",
      "groupDetailsTitle": "Grup detayları",
      "groupDescriptionFallback": "Açıklama yok.",
      "rolesCount": "Roller: {count}",
      "viewGroupDetails": "Rolleri görüntüle {name} içinde"
    }
  },
  "menu": {
    "dashboard": "Panel",
    "my-organization": "Kuruluşum",
    "userManagement": "Kullanıcı Yönetimi",
    "organizationStats": "Kuruluş İstatistikleri",
    "organizationSettings": "Kuruluş Ayarları",
    "projects": "Projeler",
    "odkServers": "ODK Sunucuları",
    "odkSync": "ODK Eşitleme",
    "payments": "Ödemeler",
    "faq": "Yardım",
    "preferences": "Hesap tercihleri",
    "settings": "Uygulama ayarları",
    "billing": "Faturalandırma",
    "help": "Yardım"
  },
  "organization": {
    "settingsSubtitle": "Kuruluş profilini, AI aboneliğini, haritaları ve bağlı altyapıyı yönetin.",
    "profile": {
      "sectionTitle": "Kuruluş profili",
      "name": "Ad",
      "description": "Açıklama",
      "edit": "Düzenle",
      "editTitle": "Kuruluşu düzenle",
      "noDescription": "Açıklama yok",
      "created": "Oluşturuldu",
      "updated": "Güncellendi",
      "loadError": "Kuruluş profili yüklenemedi"
    },
    "infrastructure": {
      "sectionTitle": "Bağlı altyapı",
      "subtitle": "Sunucular, projeler, kullanıcılar ve aktif formların özeti.",
      "servers": "ODK sunucuları",
      "projects": "Projeler",
      "users": "Kullanıcılar",
      "activeForms": "Aktif formlar",
      "defaultServer": "Varsayılan ODK sunucusu",
      "noDefaultServer": "Varsayılan sunucu seçilmedi",
      "manageServers": "ODK sunucularını yönet",
      "viewSync": "Sync Workbench'i aç",
      "loadError": "Altyapı özeti yüklenemedi"
    },
    "quickLinks": {
      "sectionTitle": "İlgili sayfalar",
      "userManagement": "Kullanıcı yönetimi",
      "statistics": "Kuruluş istatistikleri",
      "projects": "Projeler",
      "odkServers": "ODK sunucuları",
      "syncWorkbench": "Senkronizasyon",
      "reportTemplates": "Rapor şablonları"
    }
  },
  "preferences": {
    "title": "Tercihler",
    "subtitle": "Hesabınızın profilini, kuruluş erişimini, izin gruplarını ve proje rollerini gözden geçirin.",
    "accessOverview": "Erişim özeti",
    "organizationOwner": "Organizasyon sahibi",
    "organizationOwnerDescription": "Organizasyondaki tüm kaynak ve projelere tam erişiminiz var.",
    "permissionGroups": "İzin grupları",
    "permissionGroupsDescription": "Proje kapsamındaki gruplar ve rolleri",
    "perProject": "Proje bazında",
    "noProjectGroups": "Projeye özel grup yok.",
    "projectsAccess": "Proje erişimi",
    "projectsAccessDescription": "Açabileceğiniz projeler ve rolleriniz",
    "ownerNoProjects": "Organizasyon sahibi olarak tam erişiminiz var. Projeler oluşturulduğunda veya içe aktarıldığında görünecektir.",
    "noProjectAccess": "Henüz proje erişimi verilmedi.",
    "projectIdLabel": "ID: {id}",
    "projectLabelFallback": "Proje #{id}",
    "memberSince": "Üyelik tarihi:",
    "userFallback": "Kullanıcı",
    "invalidDate": "Geçersiz tarih",
    "name": "Ad",
    "email": "E-posta",
    "password": "Parola",
    "resetPassword": "Parolayı sıfırla",
    "emailSubscriptions": "E-posta abonelikleri",
    "emailSubscriptionsVisit": "Hangi e-postaları aldığınızı yönetmek için",
    "notificationSettingsLink": "Bildirim ayarları",
    "cancelAccount": "Hesabı sil",
    "cancelAccountDescription": "Organizasyonunuzu, kullanıcıları ve tüm ilişkili verileri kalıcı olarak silin.",
    "cancelAccountAction": "Hesabı sil",
    "editName": "Adı düzenle",
    "editNameSubtitle": "Uygulamada görünen adı güncelleyin.",
    "nameRequired": "Ad zorunludur",
    "nameMinLength": "Ad en az 2 karakter olmalıdır",
    "nameUpdateFailed": "Ad güncellenemedi. Lütfen tekrar deneyin.",
    "nameChangedSuccess": "Adınız başarıyla değiştirildi",
    "resetPasswordTitle": "Parolayı sıfırla",
    "resetPasswordSubtitle": "Mevcut parolanızı girin ve yeni bir parola seçin.",
    "passwordRequirementsTitle": "Parola gereksinimleri",
    "currentPassword": "Mevcut parola",
    "newPassword": "Yeni parola",
    "repeatNewPassword": "Yeni parolayı tekrarla",
    "passwordMinLength": "En az 8 karakter olmalı",
    "passwordUniqueChars": "En az 6 farklı karakter içermeli",
    "updatePassword": "Parolayı güncelle",
    "passwordChangedSuccess": "Parolanız başarıyla değiştirildi",
    "passwordUpdateFailed": "Parola güncellenemedi. Lütfen tekrar deneyin.",
    "currentPasswordRequired": "Mevcut parola alanı zorunludur",
    "newPasswordRequired": "Yeni parola alanı zorunludur",
    "repeatPasswordRequired": "Parola tekrarı alanı zorunludur",
    "passwordMatchUnique": "Yeni parola mevcut parolayla aynı olamaz",
    "confirmPasswordMismatch": "Onay, yeni parolayla eşleşmiyor",
    "dangerZoneTitle": "Tehlikeli bölge",
    "dangerZoneSubtitle": "Tüm organizasyonunuzu etkileyen geri alınamaz işlemler.",
    "cancelAccountModalTitle": "Hesabı sil",
    "cancelAccountModalSubtitle": "Kimliğinizi doğrulayın ve hesabınızı kalıcı olarak silmek istediğinizi onaylayın.",
    "cancelAccountConsequenceOrg": "Organizasyonunuz ve tüm projeler silinecek",
    "cancelAccountConsequenceUsers": "Tüm organizasyon üyeleri erişimini kaybedecek",
    "cancelAccountConsequenceOdk": "Bağlı ODK verileri kalıcı olarak kaldırılabilir",
    "cancelAccountConsequenceIrreversible": "Bu işlem geri alınamaz",
    "cancelAccountConfirmEmailLabel": "Onaylamak için e-posta adresinizi yazın",
    "cancelAccountConfirmEmailRequired": "E-posta onayı zorunludur",
    "cancelAccountConfirmEmailMismatch": "E-posta hesabınızla eşleşmiyor",
    "cancelAccountAcknowledge": "Organizasyonumun ve tüm ilişkili verilerin kalıcı olarak silineceğini anlıyorum",
    "cancelAccountAcknowledgeRequired": "Sonuçları anladığınızı onaylamalısınız",
    "cancelAccountDeleteButton": "Hesabı kalıcı olarak sil",
    "cancelAccountUnavailableTitle": "Hesap silme henüz kullanılamıyor",
    "cancelAccountUnavailableMessage": "Kimliğiniz doğrulandı. Hesap silme hazırlanıyor — hesap kapatma talebi için yöneticinize veya destek ekibine başvurun.",
    "cancelAccountWrongPassword": "Yanlış parola. Lütfen tekrar deneyin.",
    "dangerZoneCancelAccount": "Tehlikeli bölge: Hesabı sil",
    "cancelAccountWarning": "Bu, hesabınızı ve organizasyon, kullanıcılar ve bağlı ODK verileri dahil tüm ilişkili verileri kalıcı olarak silecektir.",
    "groupFallback": "Grup"
  },
  "faq": {
    "title": "Yardım",
    "subtitle": "UDACAPI'de yaygın görevler için kısa kılavuzlar ve yanıtlar."
  },
  "settings": {
    "title": "Ayarlar",
    "subtitle": "Uygulama görünümünü, dilini ve bildirim tercihlerini ayarlayın.",
    "themeSection": "Tema",
    "generalSection": "Genel tercihler",
    "notificationsNoticeTitle": "Bildirim ayarlarınız tekrar gruplandı ve basitleştirildi",
    "notificationsNoticeBody": "Önceki ayarlar seçenekleriniz değişmedi."
  },
  "projects": {
    "pageTitle": "Projeler",
    "subtitle": "Projeleri yönetin, kartlar ve tablo arasında geçiş yapın ve içe aktarma veya oluşturma akışlarını başlatın.",
    "refresh": "Yenile",
    "createProject": "Proje Oluştur",
    "importRestrictions": {
      "message": "Proje içe aktarma yalnızca kuruluşa ait sunucularda izinlidir. Paylaşılan ve Global sunucular proje içe aktarmak için kullanılamaz."
    },
    "viewMode": {
      "cards": "Kartlar",
      "table": "Tablo"
    },
    "sections": {
      "forms": {
        "title": "Proje formları"
      },
      "users": {
        "title": "Proje kullanıcıları"
      },
      "formAccess": {
        "title": "Form erişimi",
        "description": "ODK Collect’te her formu hangi App User’ların indirebileceğini seçin.",
        "save": "Kaydet",
        "discard": "Vazgeç",
        "saving": "Kaydediliyor…",
        "saved": "Form erişimi kaydedildi",
        "saveError": "Tüm değişiklikler kaydedilemedi",
        "loadError": "Form erişimi yüklenemedi",
        "emptyForms": "Bu projede yayımlanmış form yok",
        "emptyAppUsers": "Henüz App User yok. Önce bir QR kod oluşturun.",
        "openQr": "QR workbench’i aç",
        "openForms": "Formları aç",
        "dirtyHint": "Kaydedilmemiş değişiklikler"
      },
      "info": {
        "title": "Proje bilgisi",
        "basicInfo": "Temel bilgiler",
        "accessInfo": "Erişim",
        "statistics": "Proje istatistikleri",
        "fields": {
          "projectId": "Proje ID",
          "name": "Ad",
          "description": "Açıklama",
          "status": "Durum",
          "orgId": "Organizasyon ID",
          "odkProjectId": "ODK Proje ID",
          "createdAt": "Oluşturulma tarihi",
          "updatedAt": "Son güncelleme",
          "yourRole": "Rolünüz",
          "canManageForms": "Formları yönetebilir",
          "canViewUsers": "Kullanıcıları görebilir",
          "isManager": "Yönetici",
          "isOwner": "Sahip",
          "totalUsers": "Proje kullanıcıları"
        },
        "status": {
          "active": "Aktif",
          "archived": "Arşivlendi"
        },
        "noDescription": "Açıklama yok",
        "loading": "Proje bilgisi yükleniyor...",
        "loadError": "Proje bilgisi yüklenemedi",
        "statsLoadError": "Proje istatistikleri yüklenemedi",
        "invalidDate": "Geçersiz tarih",
        "notAvailable": "Yok"
      }
    },
    "users": {
      "dialog": {
        "addTitle": "Projeye kullanıcı ekle",
        "editTitle": "Projeye erişimi düzenle",
        "addSubtitle": "Önce bir kullanıcı seçin, ardından bu projeye izin gruplarını atayın.",
        "editSubtitle": "Seçilen kullanıcıyı gözden geçirin ve bu projeye izin gruplarını güncelleyin.",
        "stepOne": "Adım 1",
        "stepTwo": "Adım 2",
        "stepReady": "Hazır",
        "stepRequired": "Gerekli",
        "stepLocked": "Kilitli",
        "selectUserTitle": "Kullanıcı seç",
        "selectedUser": "Seçilen kullanıcı",
        "selectUserHint": "Bu projeye erişim alacak kullanıcıyı seçin.",
        "selectedUserHint": "Bu kullanıcı zaten bu projeye atanmış. İzin gruplarını aşağıda güncelleyebilirsiniz.",
        "selectUserPlaceholder": "Kullanıcı seç",
        "selectUserHelper": "Sahip ve super kullanıcılar bu listeden hariç tutulur.",
        "permissionGroupsTitle": "İzin grupları",
        "permissionGroupsHint": "Seçilen kullanıcı için bir veya daha fazla izin grubu seçin.",
        "permissionGroupsLockedTitle": "Bir kullanıcı seçin devam etmek için",
        "permissionGroupsLockedHint": "İzin grupları kullanıcı seçildikten sonra kullanılabilir hale gelir.",
        "addToProject": "Projeye ekle",
        "clientUser": "İstemci kullanıcısı",
        "internalUser": "İç kullanıcı"
      },
      "dialogs": {
        "removeUser": {
          "title": "Projeden kullanıcıyı sil",
          "message": "Bu kullanıcıyı projeden silmek istediğinizden emin misiniz?",
          "confirm": "Sil"
        }
      },
      "list": {
        "searchPlaceholder": "Kullanıcı ara",
        "filterByPermissionGroups": "İzin gruplarına göre filtrele",
        "accessDeniedTitle": "Erişim reddedildi",
        "accessDeniedMessage": "Bu proje kullanıcılarını görüntülemeye izin vermiyorsunuz.",
        "loadErrorTitle": "Proje kullanıcıları yüklenemedi",
        "emptyTitle": "Henüz proje kullanıcısı yok",
        "emptyMessage": "Proje kullanıcısı eklemek için ilk kullanıcıyı ekleyin.",
        "emptyFilteredTitle": "Mevcut filtrelemelere uygun kullanıcı yok",
        "emptyFilteredMessage": "Arama metnini veya seçilen izin gruplarını değiştirmeyi deneyin.",
        "noPermissionGroups": "İzin grubu yok"
      },
      "messages": {
        "saveSuccess": "Kullanıcı erişimi başarıyla güncellendi.",
        "removeSuccess": "Kullanıcı projeden silindi."
      },
      "errors": {
        "assignGroupsFailed": "İzin grupları atanamadı. Lütfen tekrar deneyin.",
        "assignRoleFailed": "Proje rolü atanamadı. Lütfen tekrar deneyin.",
        "loadUsersFailed": "Proje kullanıcıları yüklenemedi. Lütfen tekrar deneyin.",
        "permissionGroupsLoadFailed": "İzin grupları yüklenemedi. Lütfen tekrar deneyin.",
        "projectMemberRoleFailed": "Proje üyesi rolü çözümlenemedi. Lütfen tekrar deneyin.",
        "removeUserFailed": "Kullanıcı projeden silinemedi. Lütfen tekrar deneyin.",
        "rolesLoadFailed": "Proje rollerinin yüklenemedi. Lütfen tekrar deneyin.",
        "saveUserFailed": "Proje erişimi güncellenemedi. Lütfen tekrar deneyin."
      }
    },
    "modal": {
      "addProject": "Proje ekle",
      "editProject": "Projeyi düzenle",
      "unsavedChanges": "Formda kaydedilmemiş değişiklikler var. Kapatmak istediğinizden emin misiniz?"
    },
    "form": {
      "projectName": {
        "label": "Proje Adı",
        "placeholder": "Proje adı girin",
        "required": "Proje adı gerekli"
      },
      "odkServer": {
        "label": "ODK Sunucusu",
        "placeholder": "ODK sunucusu seçin",
        "required": "ODK Sunucusu gerekli",
        "noServers": "Kullanılabilir ODK sunucusu yok. Lütfen önce bir sunucu ekleyin."
      },
      "description": {
        "label": "Açıklama",
        "placeholder": "İsteğe bağlı proje açıklaması"
      },
      "buttons": {
        "cancel": "İptal"
      }
    },
    "cards": {
      "noProjects": "Proje yok",
      "status": {
        "active": "Aktif",
        "archived": "Arşivlenmiş"
      }
    },
    "confirmations": {
      "odkServerRequired": "Proje oluşturmadan önce lütfen en az bir ODK sunucusu ekleyin.",
      "delete": {
        "imported": {
          "title": "İçe aktarılan projeyi sil",
          "message": "\"{name}\" projesini silmek istediğinizden emin misiniz?\n\nBu proje ODK Central'dan içe aktarıldı. Yalnızca bu uygulamanın veritabanından silinecek, ODK Central sunucusunda kalacaktır.",
          "messageWithStats": "\"{name}\" projesini silmek istediğinizden emin misiniz?\n\nBu proje {formsCount} form ve {submissionsCount} gönderim içerir.\nProje arşivlenmiş/gizlenmiş (soft-delete) olacak ve veriler korunacaktır.\n\nBu proje ODK Central'dan içe aktarıldı. Yalnızca bu uygulamanın veritabanından silinecek, ODK Central sunucusunda kalacaktır."
        },
        "regular": {
          "title": "Projeyi sil",
          "message": "\"{name}\" projesini silmek istediğinizden emin misiniz?\n\nUYARI: Bu işlem projeyi hem bu uygulamanın veritabanından hem de ODK Central sunucusundan kalıcı olarak silecektir.",
          "messageWithStats": "\"{name}\" projesini silmek istediğinizden emin misiniz?\n\nBu proje {formsCount} form ve {submissionsCount} gönderim içerir.\nProje arşivlenmiş/gizlenmiş (soft-delete) olacak ve veriler korunacaktır.\n\nBu proje ODK Central'dan içe aktarıldı. Yalnızca bu uygulamanın veritabanından silinecek, ODK Central sunucusunda kalacaktır."
        },
        "confirmButton": "Sil"
      }
    },
    "notifications": {
      "organizationNotSelected": "Kuruluş seçilmedi"
    },
    "import": {
      "title": "ODK Projelerini İçe Aktar",
      "subtitle": "Kuruluş sunucusundan mevcut ODK projelerini yükleyin ve bu çalışma alanına içe aktarın.",
      "selectServer": "ODK Sunucusu Seçin",
      "getProjects": "Projeleri Getir",
      "availableProjects": "Mevcut Projeler",
      "noProjectsFound": "Seçilen sunucuda proje bulunamadı.",
      "importProject": "İçe Aktar",
      "imported": "İçe aktarıldı",
      "errors": {
        "serversLoadFailed": "ODK sunucuları yüklenemedi. Lütfen daha sonra tekrar deneyin.",
        "projectsLoadFailed": "ODK sunucusundan projeler yüklenemedi. Bağlantıyı kontrol edip tekrar deneyin.",
        "importFailed": "Proje içe aktarılamadı. Lütfen daha sonra tekrar deneyin.",
        "importError": "Proje içe aktarma hatası: {detail}"
      }
    },
    "importForms": {
      "title": "ODK Formlarını İçe Aktar",
      "subtitle": "ODK Central projenizden formları seçerek buraya ekleyin.",
      "subtitleWithProject": "Central projesi {odkProjectId} içindeki formları {name} projesine eklemek için seçin.",
      "loadingForms": "ODK sunucusundan formlar yükleniyor...",
      "availableForms": "Mevcut Formlar",
      "searchForms": "Form ara...",
      "selectAll": "Tümünü Seç",
      "deselectAll": "Seçimi Kaldır",
      "importSelected": "Seçilenleri İçe Aktar",
      "noFormsFound": "Bu proje için ODK sunucusunda form bulunamadı.",
      "errors": {
        "projectNotLinked": "Proje bir ODK sunucusuna bağlı değil",
        "formsLoadFailed": "ODK sunucusundan formlar yüklenemedi. Lütfen daha sonra tekrar deneyin.",
        "formsLoadError": "Formlar yüklenirken hata: {detail}",
        "importFailed": "Formlar içe aktarılamadı. Lütfen daha sonra tekrar deneyin.",
        "importError": "İçe aktarma hatası: {detail}"
      },
      "status": {
        "imported": "İçe aktarıldı",
        "available": "Mevcut"
      },
      "progress": {
        "started": "İçe aktarma başlatıldı",
        "completedSummary": "Formlar bu projede hazır.",
        "failedSummary": "Bazı formlar içe aktarılamadı. Ayrıntılar aşağıda.",
        "viewProject": "Projeyi görüntüle",
        "forms": "{done} / {total} form",
        "submissions": "{count} gönderim işlendi",
        "submissionsProgress": "{fetched} / {total} gönderim senkronize edildi",
        "stages": {
          "queued": "Başlatma bekleniyor",
          "pending": "Başlatma bekleniyor",
          "importingForms": "Formlar içe aktarılıyor",
          "syncingData": "Veriler senkronize ediliyor"
        },
        "messages": {
          "queued": "İşlem kuyruğa alındı ve başlatma bekleniyor...",
          "importingForms": "Formlar içe aktarılıyor..."
        }
      }
    },
    "detail": {
      "loading": "Proje yükleniyor...",
      "returnToProjects": "Projelere dön",
      "forms": {
        "title": "Proje formları",
        "noForms": "Projede form yok.",
        "contactAdmin": "Form eklemek için yöneticiyle iletişime geçin.",
        "actions": {
          "publish": "Yayınla",
          "abandon": "Bırak",
          "attachments": "Ekler",
          "qrCode": "Test için QR kod",
          "previewEnketo": "Enketo'da önizle",
          "downloadTestData": "Test verilerini indir",
          "formSettings": "Form ayarları",
          "viewDetails": "Görüntüle/Detaylar",
          "changeState": "Durumu değiştir",
          "delete": "Sil/Bırak"
        },
        "modals": {
          "qrCode": {
            "title": "Test için QR kod",
            "description": "Formu test etmek için QR kodu tarayın"
          },
          "formSettings": {
            "title": "Form ayarları",
            "basicSettings": "Temel ayarlar (Yer tutucu)",
            "accessSettings": "Erişim ayarları (Yer tutucu)",
            "placeholder": "Bu bir gösterim arayüzüdür. İşlevsellik geliştirme aşamasındadır."
          }
        },
        "messages": {
          "tryAgain": "Tekrar dene",
          "publishing": "{name} formu yayınlanıyor...",
          "published": "{name} formu başarıyla yayınlandı",
          "previewing": "Enketo'da {name} önizleniyor (geliştirme yer tutucusu)",
          "downloading": "{name} için test verileri indiriliyor (geliştirme yer tutucusu)",
          "saving": "{name} için ayarlar kaydediliyor (geliştirme yer tutucusu)",
          "missingData": "Form içe aktarmak için veri eksik",
          "missingXlsformData": "XLSForm yüklemek için veri eksik",
          "noAttachments": "Formda ek yok"
        }
      }
    },
    "qc": {
      "rules": {
        "ruleTypes": {
          "required": "Required field",
          "constraint": "Constraint",
          "calculation": "Calculation",
          "custom": "Custom"
        },
        "severity": {
          "error": "Error",
          "warning": "Warning",
          "info": "Info"
        },
        "form": {
          "tabs": {
            "basic": "Basic settings",
            "preview": "Preview"
          },
          "ruleNameLabel": "Rule name *",
          "ruleNamePlaceholder": "Enter rule name",
          "ruleTypeLabel": "Rule type *",
          "severityLabel": "Severity level *",
          "fieldPathLabel": "Field path *",
          "fieldPathPlaceholder": "respondent.age",
          "constraintExpressionLabel": "Constraint expression *",
          "calculationFormulaLabel": "Calculation formula *",
          "simpleEditor": "Simple editor",
          "jsonLogicBuilder": "JSONLogic Builder",
          "applyJsonLogic": "Apply JSONLogic",
          "errorMessageLabel": "Error message *",
          "errorMessagePlaceholder": "Enter error message",
          "activeLabel": "Rule active",
          "previewTitle": "Rule Preview",
          "runPreview": "Run Preview",
          "previewHint": "Tests rule on sample data",
          "invalidJson": "Invalid JSON format",
          "createExpressionFirst": "Create rule expression first",
          "previewError": "Error executing preview",
          "previewResults": "Preview results ({count} records):",
          "passed": "Passed:",
          "failed": "Failed:",
          "successRate": "Success rate:",
          "validation": {
            "ruleNameRequired": "Rule name is required",
            "fieldPathRequired": "Field path is required",
            "errorMessageRequired": "Error message is required",
            "constraintExpressionRequired": "Constraint expression is required",
            "calculationFormulaRequired": "Calculation formula is required"
          },
          "toasts": {
            "ruleCreated": "Rule created successfully",
            "ruleUpdated": "Rule updated successfully",
            "saveError": "Error saving rule"
          }
        }
      }
    }
  },
  "odkServers": {
    "title": "ODK Sunucuları",
    "subtitle": "Kuruluş ODK uç noktalarını, varsayılanlarını, görünürlüklerini ve bağlantı sağlığını yönetin.",
    "addServer": "Sunucu ekle",
    "editServer": "Sunucuyu düzenle",
    "deleteServer": "Sunucuyu sil",
    "modal": {
      "addSubtitle": "Bu organizasyona bir ODK Central sunucusu bağlayın.",
      "editSubtitle": "Sunucu bağlantı ayarlarını güncelleyin."
    },
    "table": {
      "default": "Varsayılan",
      "visibility": "Görünürlük",
      "setAsDefault": "Varsayılan yap",
      "setAsDefaultTooltip": "Bu kuruluş için varsayılan sunucu olarak ayarla",
      "testConnection": "Bağlantıyı test et",
      "testConnectionTooltip": "ODK Central sunucusuna bağlantıyı test et",
      "testConnectionDisabled": "Bağlantı testi yalnızca kuruluşa ait sunucular için kullanılabilir",
      "editServer": "Sunucuyu düzenle",
      "editServerTooltip": "Sunucu detaylarını düzenle (yalnızca KURULUŞ sunucuları ve yetkilerle)",
      "deleteServer": "Sunucuyu sil",
      "deleteServerTooltip": "Sunucuyu sil (yalnızca KURULUŞ sunucuları ve yetkilerle)",
      "odkSession": "ODK oturumu"
    },
    "session": {
      "banner": "Bir veya daha fazla sunucunun ODK Central oturumu süresi doluyor veya geçersiz ya da kayıtlı şifre yok. Uygulamanın otomatik yeniden bağlanabilmesi için sunucuyu düzenleyip şifreyi kaydedin.",
      "ok": "Oturum tamam",
      "expiresSoon": "Yakında sona eriyor",
      "expired": "Süresi doldu",
      "unknown": "Bilinmiyor",
      "noStoredPassword": "Şifre kaydedilmedi"
    },
    "form": {
      "serverName": "Sunucu adı",
      "serverUrl": "Sunucu URL",
      "serverUrlPlaceholder": "https://your-odk-central.com",
      "username": "Kullanıcı adı",
      "password": "Parola",
      "passwordPlaceholderEdit": "Değiştirmemek için boş bırakın",
      "description": "Açıklama",
      "serverIsActive": "Sunucu aktif",
      "serverIsActiveHint": "Etkin olmayan sunucular listede kalır ancak proje oluştururken sunulmaz."
    },
    "validation": {
      "serverNameRequired": "Sunucu adı gerekli",
      "serverUrlRequired": "Sunucu URL gerekli",
      "urlFormatInvalid": "URL http:// veya https:// ile başlamalı",
      "usernameRequired": "Kullanıcı adı gerekli",
      "passwordRequired": "Parola gerekli"
    },
    "messages": {
      "selectOrganizationFirst": "Lütfen önce bir kuruluş seçin veya oluşturun",
      "loadingServers": "Sunucular yükleniyor...",
      "noServersFound": "Bu kuruluş için ODK sunucusu bulunamadı",
      "failedToLoadServers": "Sunucular yüklenemedi",
      "noServers": "ODK sunucusu yok",
      "serverSaved": "Sunucu \"{name}\" başarıyla {action}!",
      "serverSetAsDefault": "Sunucu \"{name}\" varsayılan olarak ayarlandı",
      "connectionTestSuccess": "Bağlantı tamam. Bulunan projeler: {count}",
      "connectionTestFailed": "Bağlantı testi başarısız"
    },
    "contextHint": "Formları senkronize etmeden veya içe aktarmadan önce ODK sunucunuzu bağlayın."
  },
  "notifications": {
    "all": "Tüm bildirimleri gör",
    "less": "Daha az bildirim"
  },
  "language": {
    "label": "Dil",
    "english": "İngilizce",
    "spanish": "İspanyolca",
    "french": "Fransızca",
    "swahili": "Svahili",
    "portuguese": "Portekizce",
    "ukrainian": "Ukraynaca",
    "russian": "Rusça",
    "turkish": "Türkçe"
  },
  "auth": {
    "createAccount": "Hesap oluştur",
    "dontHaveAccount": "Hesabınız yok mu?",
    "email": "E-posta",
    "emailInvalid": "E-posta geçerli olmalı",
    "emailRequired": "E-posta alanı zorunludur",
    "enterEmail": "E-posta adresinizi girin",
    "enterVerificationCode": "Lütfen doğrulama kodunu girin",
    "forgotPassword": "Parolayı mı unuttunuz?",
    "forgotPasswordDescription": "Parolanızı unuttuysanız endişelenmeyin. Aşağıya e-posta adresinizi girin, parola sıfırlama talimatlarını içeren bir e-posta göndereceğiz. Hesabınıza erişimi yeniden sağlamak hiç bu kadar kolay olmamıştı.",
    "fullName": "Ad Soyad",
    "fullNameRequired": "Ad Soyad alanı zorunludur",
    "goBack": "Geri dön",
    "haveAccount": "Hesabınız var mı?",
    "login": "Giriş",
    "password": "Parola",
    "passwordMustContainLetter": "Parola en az bir harf içermeli",
    "passwordMustContainNumber": "Parola en az bir rakam içermeli",
    "passwordMustContainSpecial": "Parola en az bir özel karakter içermeli",
    "passwordMustBe8Chars": "Parola en az 8 karakter olmalı",
    "passwordRequired": "Parola alanı zorunludur",
    "passwordRequirements": "Parola 8+ karakter olmalı: harf, rakam ve özel karakter.",
    "passwordsDontMatch": "Parolalar eşleşmiyor",
    "registrationFailed": "Kayıt başarısız. Lütfen tekrar deneyin.",
    "registrationSuccess": "Başarıyla kaydoldunuz! Aktivasyon talimatları için e-postanızı kontrol edin.",
    "repeatPassword": "Parolayı Tekrarla",
    "repeatPasswordRequired": "Parola tekrar alanı zorunludur",
    "resetInstructionsSent": "Parola sıfırlama talimatları e-postanıza gönderildi.",
    "resetInstructionsFailed": "Parola sıfırlama e-postası gönderilemedi. Lütfen tekrar deneyin.",
    "resetPassword": "Parolayı sıfırla",
    "sendResetInstructions": "Sıfırlama talimatlarını gönder",
    "signUp": "Kayıt Ol",
    "twoFactorAuthentication": "İki Faktörlü Doğrulama",
    "verificationCode": "Doğrulama Kodu",
    "verificationCodeRequired": "Doğrulama kodu zorunludur",
    "verifyCode": "Kodu Doğrula"
  },
  "dashboard": {
    "subtitle": "Görselleştirilmiş istatistikler ve önemli bilgiler için giriş sayfası.",
    "activeFormsTitle": "Aktif Formlar",
    "activeFormsSubtitle": "Aktif formların sayısı ve durumu.",
    "noActiveForms": "Aktif form yok"
  },
  "qr": {
    "title": "QR Kod (ODK Collect Ayarları)",
    "titleShort": "QR Kod",
    "qrName": "QR kod adı",
    "projectSection": "Proje",
    "projectName": "Proje adı",
    "projectIcon": "Proje simgesi",
    "projectColor": "Proje rengi",
    "generalSection": "Genel ayarlar",
    "serverUrl": "Sunucu URL",
    "username": "Kullanıcı adı",
    "password": "Parola",
    "adminSection": "Yönetici ayarları",
    "admin": {
      "edit_saved": "Kaydedileni düzenle",
      "send_finalized": "Sonlandırılanı gönder",
      "view_sent": "Gönderileni görüntüle",
      "password": "Yönetici parolası",
      "advanced": "Gelişmiş yönetici",
      "getBlank": "Boş al",
      "deleteSaved": "Kaydedileni sil",
      "qrCodeScanner": "QR kod tarayıcı",
      "changeServer": "Sunucuyu değiştir",
      "changeAppTheme": "Uygulama temasını değiştir",
      "changeAppLanguage": "Uygulama dilini değiştir",
      "changeFontSize": "Yazı boyutunu değiştir",
      "changeNavigation": "Gezinmeyi değiştir",
      "maps": "Haritalar",
      "periodicUpdates": "Periyodik güncellemeler",
      "automaticUpdate": "Otomatik güncelleme",
      "hideOldVersions": "Eski sürümleri gizle",
      "changeAutosend": "Otomatik gönderimi değiştir",
      "deleteAfterSend": "Gönderdikten sonra sil",
      "defaultToFinalized": "Varsayılan sonlandırılmış",
      "changeConstraintBehavior": "Kısıt davranışını değiştir",
      "highResolution": "Yüksek çözünürlük",
      "imageSize": "Görsel boyutu",
      "guidanceHint": "Rehber ipucu",
      "externalAppRecording": "Harici uygulama kaydı",
      "instanceFormSync": "Örnek form eşitleme",
      "changeFormMetadata": "Form meta verisini değiştir",
      "analytics": "Analitik",
      "movingBackwards": "Geriye gitme",
      "accessSettings": "Erişim ayarları",
      "changeLanguage": "Dili değiştir",
      "jumpTo": "Atla",
      "saveMid": "Ortada kaydet",
      "saveAs": "Farklı kaydet",
      "markAsFinalized": "Sonlandırılmış işaretle"
    },
    "general": {
      "theme": "Tema",
      "language": "Dil",
      "fontSize": "Yazı boyutu",
      "navigation": "Gezinme",
      "constraintBehavior": "Kısıt davranışı",
      "advanced": "Gelişmiş genel",
      "formlistUrl": "Form listesi URL",
      "submissionUrl": "Gönderim URL",
      "periodicUpdates": "Periyodik güncellemeler",
      "deleteAfterSend": "Gönderdikten sonra sil",
      "defaultCompleted": "Varsayılan tamamlandı",
      "externalAppRecording": "Harici uygulama kaydı"
    },
    "formManagement": {
      "title": "Form yönetimi",
      "updateMode": "Güncelleme modu",
      "autosend": "Otomatik gönder",
      "imageSize": "Görsel boyutu",
      "automaticUpdate": "Otomatik güncelleme",
      "hideOldVersions": "Eski sürümleri gizle",
      "instanceSync": "Örnek eşitleme",
      "guidanceHint": "Rehber ipucu",
      "highResolution": "Yüksek çözünürlük"
    },
    "maps": {
      "title": "Haritalar",
      "basemap": "Alt harita",
      "googleStyle": "Google stili",
      "mapboxStyle": "Mapbox stili",
      "usgsStyle": "USGS stili",
      "cartoStyle": "CARTO stili",
      "referenceLayer": "Referans katmanı (yol)"
    },
    "identity": {
      "title": "Kimlik",
      "analytics": "Analitik",
      "userName": "Kullanıcı adı",
      "email": "E-posta",
      "phone": "Telefon"
    },
    "presets": {
      "title": "QR Ön Ayarları",
      "save": "Ön Ayar Kaydet",
      "load": "Ön ayar yükle...",
      "delete": "Sil",
      "defaultName": "Ön Ayar {number}"
    },
    "preview": {
      "title": "JSON Önizleme",
      "reset": "Sıfırla",
      "import": "İçe Aktar"
    },
    "history": {
      "title": "Oluşturulan QR Kodları",
      "viewAll": "Tümünü Görüntüle",
      "view": "Görüntüle",
      "download": "İndir",
      "copy": "Kopyala",
      "delete": "Sil",
      "more": "... ve {count} tane daha"
    },
    "actions": {
      "generate": "QR Oluştur",
      "downloadPng": "PNG İndir",
      "copyBase64": "Base64 Kopyala",
      "reset": "Sıfırla",
      "importJson": "JSON İçe Aktar"
    },
    "placeholders": {
      "qrName": "Cihazım QR",
      "color": "#C17A3A",
      "url": "https://central.example.org",
      "submissionUrl": "https://.../v1/projects/:id/submissions",
      "referenceLayer": "/storage/maps/layer.mbtiles",
      "icon": "📋",
      "projectName": "Saha ekibi"
    },
    "options": {
      "default": "Varsayılan",
      "system": "Sistem"
    },
    "messages": {
      "nameRequiredForPreset": "Lütfen ön ayar için bir ad girin",
      "nameRequiredForAppUser": "Uygulama Kullanıcısı oluşturmak için QR Kod adı gerekli",
      "invalidSettings": "Geçersiz ayarlar",
      "generateError": "QR oluşturma ve Uygulama Kullanıcısı oluşturma başarısız",
      "invalidJsonStructure": "Geçersiz JSON yapısı. project, general ve admin bölümlerini içermeli.",
      "invalidJsonFormat": "Geçersiz JSON biçimi",
      "copyBase64Error": "Base64 kopyalanamadı",
      "projectNameRequired": "Proje adı gerekli",
      "serverRequired": "Sunucu URL’si gerekli",
      "missingOdkProject": "Bu projenin ODK Central proje kimliği yok. Yeniden içe aktarın veya ayarları kontrol edin.",
      "generateSuccess": "QR oluşturuldu ve App User yaratıldı",
      "presetSaved": "Ön ayar kaydedildi",
      "base64Copied": "Base64 kopyalandı",
      "jsonImported": "Ayarlar JSON’dan içe aktarıldı"
    },
    "placeholder": "Görmek için bir QR kodu oluşturun",
    "note": "Kod, general/admin/project ayarlarıyla JSON’un zlib sıkıştırmalı Base64’ünü içerir. App User kimlik doğrulaması server_url içindedir.",
    "workbench": {
      "contextHint": "Sunucu URL’sine App User jetonu gömülü bir ODK Collect QR oluşturun.",
      "serverReady": "Sunucu ayarlı",
      "essentialsTitle": "Yapılandır",
      "essentialsDesc": "QR ve Collect kartına ad verin, ikon ve renk seçin, sonra oluşturun.",
      "nameHint": "ODK Central’da App User görünen adı olarak da kullanılır.",
      "serverHint": "Projeye bağlı ODK sunucusundan alınır. Oluşturma /v1/key/{token}/projects/{id} ekler.",
      "advancedTitle": "Gelişmiş Collect seçenekleri",
      "advancedHint": "Tema, form senkronu, haritalar — isteğe bağlı",
      "previewTitle": "Önizleme",
      "previewDesc": "Oluşturduktan sonra ODK Collect ile tarayın.",
      "libraryHint": "Bu tarayıcıda bu proje için saklanır.",
      "libraryEmpty": "Henüz QR yok. Başlamak için bir tane oluşturun.",
      "libraryCount": "kitaplıkta {count}",
      "serverMeta": "Central: {url}",
      "serverMissing": "Central: bağlı değil — projenin ODK sunucusunu kontrol edin",
      "projectNameHint": "Bu yapılandırma için ODK Collect etiketi (udacapi proje adı değil).",
      "iconHint": "Collect proje kartında gösterilir. Varsayılan çoğu ekip için yeterlidir.",
      "changeIcon": "İkonu değiştir",
      "iconDialogTitle": "Collect proje ikonu",
      "iconDialogSubtitle": "Cihazdaki proje kartı için bir glif seçin.",
      "applyIcon": "İkonu kullan"
    },
    "formAccess": {
      "title": "Bu toplayıcının erişebileceği formlar",
      "hint": "En az bir yayımlanmış form seçin. Aksi halde Collect boş bir liste gösterir.",
      "selectAll": "Tümünü seç",
      "clear": "Temizle",
      "required": "En az bir form seçin",
      "assignFailed": "Formlar App User’a atanamadı",
      "manageAll": "Tüm form erişimini yönet",
      "formsCount": "{n} form",
      "noPublishedForms": "Bu projede henüz yayımlanmış form yok."
    }
  },
  "forms": {
    "state": {
      "open": "Açık",
      "closing": "Kapanıyor",
      "closed": "Kapalı",
      "draft": "Taslak"
    },
    "deleteConfirm": {
      "title": "Formu sil",
      "subtitle": "Bu formu kalıcı olarak silmeden önce sonuçları gözden geçirin.",
      "message": "Bu işlem geri alınamaz.",
      "xmlFormId": "XML ID: {id}",
      "confirm": "Kalıcı olarak sil",
      "importedWarning": "Bu form ODK Central'dan içe aktarıldı. Yalnızca bu uygulamanın veritabanından silinecek, ODK Central sunucusunda kalacaktır.",
      "regularWarning": "Bu işlem formu ODK Central çöp kutusuna taşır ve yerel olarak silinmiş olarak işaretler.",
      "consequenceDataLoss": "Bu forma ait tüm gönderimler ve dışa aktarma geçmişi bu uygulamadan kaldırılacaktır.",
      "irreversible": "Bu işlem arayüzden geri alınamaz.",
      "success": "Form {name} silindi.",
      "successImported": "Form {name} yalnızca uygulama veritabanından silindi.",
      "error": "Form silme hatası: {error}"
    },
    "uploadXlsform": {
      "title": "XLSForm Yükle",
      "subtitle": "Form oluşturmak veya güncellemek için bir çalışma kitabı seçin (.xlsx veya .xls, en fazla 50 MB).",
      "selectFile": "XLSForm dosyası seçin",
      "dropFileTitle": "XLSForm dosyanızı buraya bırakın",
      "supportedFormats": "Kabul edilen biçimler: .xlsx ve .xls, en fazla 50 MB.",
      "replaceFileHint": "Mevcut seçimi değiştirmek için başka bir dosya seçin.",
      "chooseFile": "Dosyalara göz at",
      "selectedFile": "Seçilen dosya:",
      "formSettings": "Form tanımlayıcısı",
      "uploadOptions": "Yükleme seçenekleri",
      "formId": "Form ID",
      "formIdPlaceholder": "my_form_id",
      "formIdHint": "Form ID XLSForm'dan ('settings' sayfası) otomatik çıkarılacaktır. Bu alan yalnızca yedek olarak kullanılır.",
      "formIdWarning": {
        "title": "Önemli!",
        "message": "Nihai form ID'si XLSForm dosyasının 'settings' sayfasından alınacaktır. Buraya girilen ID yalnızca yedek seçenek olarak kullanılır."
      },
      "updateExisting": "Mevcut formu güncelle",
      "updateExistingHint": "Bu ID'ye sahip bir form zaten varsa güncellenecektir",
      "ignoreWarnings": "Uyarıları yoksay",
      "ignoreWarningsHint": "Dönüştürme sırasında uyarıları yoksay",
      "publishImmediately": "Formu hemen yayınla",
      "publishImmediatelyHint": "Formu hemen yayınla",
      "uploadButton": "XLSForm Yükle",
      "uploading": "Yükleniyor...",
      "noFileSelected": "Yüklemek için lütfen bir dosya seçin",
      "noFormId": "Lütfen form ID'sini girin",
      "uploadingMessage": "XLSForm \"{formId}\" yükleniyor...",
      "successMessage": "XLSForm \"{formId}\" başarıyla yüklendi!",
      "errorMessage": "Yükleme hatası: {error}",
      "errorFallback": "Yükleme başarısız. Lütfen tekrar deneyin.",
      "listUpdated": "XLSForm başarıyla yüklendi! Liste güncellendi."
    },
    "formDetail": {
      "loading": "Form yükleniyor...",
      "formLabel": "Form",
      "returnToProjects": "Proje listesine dön",
      "sectionShell": {
        "unknownForm": "Bilinmeyen form",
        "loading": "Yükleniyor...",
        "retry": "Tekrar Dene",
        "comingSoonTitle": "Yakında",
        "comingSoonDescription": "Bu özellik geliştirilmektedir. Lütfen diğer form araçlarını kullanın."
      },
      "sections": {
        "dashboard": {
          "title": "Form Özeti",
          "description": "Form ve toplanan veriler hakkında istatistikler ve bilgiler"
        },
        "qc": {
          "title": "Kalite Kontrolü",
          "description": "QC kuralları kullanarak veri kalitesini izleyin ve doğrulayın",
          "workbench": {
            "contextHint": "Bu form için kuralları tanımlayın, gönderimleri doğrulayın ve işaretlenmiş sorunları gözden geçirin.",
            "rulesCount": "{count} kurallar",
            "activeCount": "{count} aktif",
            "validationsCount": "{count} doğrulamalar",
            "summaryTitle": "Kurallar Özeti",
            "selectedCount": "{count} seçildi",
            "createRuleHint": "Bu form için yeni bir doğrulama kuralı tanımlayın",
            "editRuleHint": "Kural ayarlarını ve ifadesini güncelleyin",
            "backToRules": "Kurallara dön",
            "pipeline": {
              "ariaLabel": "QC doğrulama işlem akışı",
              "define": "Kuralları tanımla",
              "defineHint": "{count} kurallar yapılandırıldı",
              "defineEmpty": "Henüz kurallar yok — ilk doğrulamayı oluşturun",
              "validate": "Veriyi doğrula",
              "validateHint": "{count} gönderimler kontrol edildi",
              "validateEmpty": "Gelen gönderimlerde doğrulama çalıştırın",
              "review": "Sorunları gözden geçirin",
              "reviewHint": "{count} açık sorunlar",
              "reviewClear": "Çözülmemiş sorun yok"
            }
          }
        },
        "dataExport": {
          "title": "Veri Dışa Aktarma",
          "description": "Form verilerini çeşitli biçimlerde dışa aktarın"
        },
        "odkExport": {
          "title": "Veri Dışa Aktarma",
          "description": "Analiz için form verilerini çeşitli biçimlerde dışa aktarın",
          "unknownForm": "Bilinmeyen Form",
          "exportsCount": "{count} dışa aktarma",
          "loadingOptions": "Dışa aktarma seçenekleri yükleniyor...",
          "retry": "Tekrar Dene",
          "infoSubtitleDetailed": "Form verilerinizi indirmek için dışa aktarma biçimlerini seçin ve seçenekleri yapılandırın.",
          "formatsAvailable": "{count} biçim mevcut",
          "formatsTitle": "Dışa Aktarma Biçimleri",
          "selectFormats": "Dışa aktarmak için bir veya daha fazla biçim seçin",
          "statisticalFormatsTitle": "İstatistiksel Biçimler",
          "geoFormatsTitle": "Coğrafi Biçimler",
          "noGeoData": "Bu formda coğrafi veri bulunamadı",
          "configTitle": "Dışa Aktarma Yapılandırması",
          "configSubtitle": "Dışa aktarma seçeneklerini ve filtreleri yapılandırın",
          "dataOptions": "Veri Seçenekleri",
          "includeRepeats": "Tekrarlayan grupları dahil et",
          "includeLabels": "Alan etiketlerini dahil et",
          "includeMetadata": "Meta veriyi dahil et",
          "labelLanguage": "Etiket Dili",
          "selectLanguage": "Dil seçin",
          "loadingLanguages": "Diller yükleniyor...",
          "generatingLabels": "Etiketler oluşturuluyor...",
          "noLabelsAvailable": "Etiket yok. Etiket oluşturmak için yenile'ye tıklayın.",
          "filters": "Filtreler",
          "dateRange": "Tarih Aralığı",
          "startDate": "Başlangıç Tarihi",
          "endDate": "Bitiş Tarihi",
          "dataFilter": "Veri Filtresi",
          "dataFilterPlaceholder": "örn. yaş > 18",
          "readyToExport": "Dışa Aktarmaya Hazır",
          "readyToExportSubtitle": "Dışa aktarma işlemini başlatmak için düğmeye tıklayın",
          "labelsRequiredNotice": "Etiketler gerekli ancak mevcut değil. Lütfen önce etiketleri oluşturun.",
          "activeExports": "Aktif Dışa Aktarmalar",
          "exportButton": "Veriyi Dışa Aktar",
          "historyTitle": "Dışa Aktarma Geçmişi",
          "historySubtitle": "Önceki dışa aktarmaları görüntüleyin ve indirin",
          "refresh": "Yenile",
          "loadingHistory": "Geçmiş yükleniyor...",
          "noHistory": "Henüz dışa aktarma yok",
          "noHistoryDesc": "Tercih ettiğiniz biçimde veri dışa aktararak başlayın.",
          "workbench": {
            "contextHint": "Biçimleri ve seçenekleri seçin, ardından dışa aktarma çalıştırın.",
            "geoAvailable": "Coğrafi veri",
            "geoUnavailable": "Coğrafi veri yok",
            "optionsTitle": "Seçenekler",
            "refreshLabels": "Etiketleri yenile",
            "labelsGenerated": "Etiketler oluşturuldu ({count} diller)",
            "exportButtonOne": "1 biçim dışa aktar",
            "exportButtonMany": "{count} biçim dışa aktar",
            "selectFormatHint": "En az bir biçim seçin.",
            "readySummaryOne": "1 biçim dışa aktarma hazır.",
            "readySummaryMany": "{count} biçim dışa aktarma hazır.",
            "jobsTitle": "İşler",
            "jobsSubtitle": "Aktif dışa aktarmaları izleyin ve önceki dosyaları indirin.",
            "noActiveJobs": "Dışa aktarmalar çalışmıyor.",
            "noHistoryAction": "Bir biçim seçin ve dışa aktarma çalıştırın.",
            "pipeline": {
              "sync": "Veriyi eşitle",
              "convert": "Dönüştür",
              "ready": "Hazır"
            }
          },
          "date": "Tarih",
          "format": "Biçim",
          "records": "Kayıtlar",
          "size": "Boyut",
          "user": "Kullanıcı",
          "actions": "İşlemler",
          "download": "İndir",
          "viewError": "Hatayı Görüntüle",
          "errorDetails": "Hata Detayları",
          "errorSubtitle": "Dışa aktarma hata bilgisi",
          "close": "Kapat",
          "deleteTitle": "Dışa Aktarmayı Sil",
          "deleteSubtitle": "Bu işlem geri alınamaz",
          "deleteConfirm": "{date} tarihli dışa aktarmayı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
          "cancel": "İptal",
          "delete": "Sil",
          "formatDescriptions": {
            "stata": "Stata",
            "spss": "SPSS",
            "excel": "Excel",
            "csv": "CSV",
            "geojson": "GeoJSON",
            "shapefile": "ESRI Shapefile",
            "kml": "KML",
            "odata": "OData"
          },
          "dateFilters": {
            "all": "Tüm veriler",
            "last30": "Son 30 gün",
            "last90": "Son 90 gün",
            "thisyear": "Bu yıl",
            "lastyear": "Geçen yıl",
            "custom": "Özel aralık"
          },
          "status": {
            "odataSyncError": "OData eşitleme kontrol hatası: {error}",
            "localDataMissing": "Yerel veri eksik, OData indiriliyor...",
            "odataStatusError": "OData durum hatası",
            "downloadingOdata": "OData indiriliyor...",
            "downloadSuccessCount": "{count} gönderim indirildi",
            "downloadError": "OData indirme hatası: {error}",
            "geoRequired": "{format} coğrafi veri gerektirir"
          },
          "notifications": {
            "selectFormat": "Lütfen en az bir biçim seçin",
            "startingDownload": "İndirme başlıyor...",
            "downloadSuccess": "Dosya başarıyla indirildi",
            "downloadError": "İndirme hatası: {error}",
            "taskIdMissing": "İndirilemiyor: görev ID eksik",
            "exportDeleted": "Dışa aktarma başarıyla silindi",
            "exportCompleted": "{format} dışa aktarma tamamlandı",
            "exportFailed": "{format} dışa aktarma başarısız",
            "trackingError": "İzleme hatası: {error}",
            "noErrorDetails": "Hata detayı yok",
            "currentUser": "Mevcut Kullanıcı"
          }
        },
        "dataAnalysis": {
          "title": "Veri Analizi",
          "description": "Ad-hoc analiz için pivot tablolar oluşturun ve görünümleri izlemeye kaydedin",
          "recordsLoaded": "{count} kayıt yüklendi",
          "variablesSelected": "{count} değişken seçildi",
          "tablesAvailable": "{count} tablo mevcut",
          "workbench": {
            "contextHint": "Değişkenleri seçin, pivot tablo ile keşfedin, ardından görünümü izlemeye kaydedin",
            "loadingData": "Veri yükleniyor...",
            "pipeline": {
              "ariaLabel": "Analiz işlem akışı",
              "source": "Veri kaynağı",
              "sourceHint": "{table}",
              "sourceEmpty": "Veri tablosu seçin",
              "variables": "Değişkenler",
              "variablesHint": "{count} seçildi",
              "variablesEmpty": "Analiz için alanları seçin",
              "pivot": "Pivot tablo",
              "pivotHint": "{count} kayıt yüklendi",
              "pivotEmpty": "Veri yükleyin",
              "pivotLoading": "Kayıt yükleniyor...",
              "save": "Görünümü kaydet",
              "saveHint": "İzlemeye kaydetmeye hazır",
              "saveEmpty": "Pivot tabloyu önce yapılandırın"
            },
            "source": {
              "title": "Veri kaynağı",
              "subtitle": "Hangisi gönderim tablosu ve değerlerin nasıl görüntüleneceğini seçin",
              "labelsMissing": "Etiketler bu form için oluşturulmamış",
              "labelsMissingHint": "Değişken adlarını ve değer etiketlerini göstermek için XLSForm'dan etiketler oluşturun.",
              "generateLabels": "Etiketleri oluştur",
              "table": "Veri tablosu",
              "tablePlaceholder": "Veri tablosu seçin",
              "displayOptions": "Görüntüleme seçenekleri",
              "showLabels": "Etiketleri göster",
              "language": "Dil",
              "includeMetadata": "Meta veriyi dahil et"
            },
            "variables": {
              "title": "Değişkenler",
              "selectedCount": "{count} seçildi",
              "selectTableFirst": "Veri tablosu seçin, mevcut değişkenleri görüntüleyin.",
              "selectAll": "Tümünü seç",
              "clearAll": "Tümünü temizle",
              "searchPlaceholder": "Değişkenleri arayın...",
              "empty": "Aramanıza uyan değişken yok",
              "moreCount": "+{count} daha fazla",
              "loading": "Yükleniyor...",
              "loadCta": "{count} değişken yükleniyor"
            },
            "pivot": {
              "title": "Pivot tablo",
              "subtitle": "Alanları satır, sütun veya değerlere sürükleyerek görünümü oluşturun",
              "hint": "Değişkenleri satır, sütun veya değerlere sürükleyerek görünümü oluşturun. Layout doğru görünüyorsa, izleme tablosu olarak kaydedin.",
              "reprocess": "Analizleri yeniden işle",
              "saveCta": "İzlemeye kaydet",
              "analyticsProcessed": "{percent}% işlendi"
            },
            "empty": {
              "title": "Değişkenleri seçin",
              "hint": "Seçilen tablodan bir veya daha fazla değişken seçerek analizi başlatın."
            },
            "save": {
              "title": "İzleme tablosu kaydet",
              "subtitle": "Bu pivot görünümüne bir ad verin, böylece izleme sayfasında bulunabilirsiniz.",
              "tableName": "Tablo adı",
              "tableNamePlaceholder": "Tablo adı girin",
              "description": "Açıklama",
              "descriptionPlaceholder": "Bu tablo ne izler?",
              "summary": "Analiz özeti",
              "variables": "Değişkenler",
              "table": "Tablo",
              "cancel": "İptal",
              "confirm": "Tablo kaydet"
            },
            "toasts": {
              "labelsGenerated": "Etiketler oluşturuldu. Değişkenler yeniden yükleniyor...",
              "labelsFailed": "Etiketler oluşturulamadı. XLSForm'un mevcut olduğunu kontrol edin.",
              "saveSuccess": "Tablo kaydedildi. İzleme sayfasını açarak görüntüleyin.",
              "saveFailed": "Tablo kaydedilemedi. Lütfen tekrar deneyin veya destek ile iletişime geçin.",
              "formIdMissing": "Form ID bulunamadı",
              "reprocessSuccess": "Analizler yeniden işlendi: {count} yeni kayıt",
              "reprocessFailed": "Analizler yeniden işlenemedi",
              "reprocessError": "Analizler yeniden işlenirken hata: {error}"
            }
          }
        },
        "dataMonitoring": {
          "title": "Veri İzleme",
          "description": "Kaydedilmiş izleme tablolarını gerçek zamanlı güncellemelerle görüntüleyin",
          "tablesCount": "{count} tablo",
          "updating": "Güncelleniyor...",
          "workbench": {
            "contextHint": "Kaydedilmiş pivot görünümleri, bu sayfa açıkken canlı veri yenilemeyle görüntülenir",
            "activeViewsCount": "{count} aktif",
            "liveStrip": {
              "ariaLabel": "İzleme durumu",
              "saved": "Kaydedilmiş tablolar",
              "savedHint": "{count} tablo hazır",
              "savedEmpty": "Henüz tablo kaydedilmedi",
              "watch": "Aktif görünüm",
              "watchHint": "{title} görüntüleniyor",
              "watchEmpty": "Görüntülemek için bir tablo seçin",
              "watchDisabled": "Önce bir tablo oluşturun",
              "sync": "Canlı eşitleme",
              "syncHint": "Her 30 saniyede bir güncellenir",
              "syncActive": "Şimdi yenileniyor..."
            },
            "displayOptions": {
              "title": "Görüntüleme seçenekleri",
              "subtitle": "Değişken adlarının pivot tablolarında nasıl görüntüleneceğini kontrol edin",
              "showLabels": "Etiketleri göster",
              "language": "Dil"
            },
            "summary": {
              "title": "Bir bakışta",
              "tables": "Kaydedilmiş tablolar",
              "activeView": "Aktif görünüm",
              "records": "Görüntülenen kayıtlar",
              "refreshInterval": "Otomatik yenileme"
            },
            "tables": {
              "title": "İzleme tabloları",
              "subtitle": "Kaydedilmiş pivot görünümleri veri analizinden",
              "loading": "İzleme tabloları yükleniyor...",
              "emptyTitle": "Henüz izleme tablo yok",
              "emptyHint": "Analiz sayfasında bir pivot tablo oluşturun ve buraya kaydedin.",
              "createCta": "Analize git",
              "realtimeHint": "Veri her 30 saniyede bir güncellenir. Yenileme ile anında güncelleme yapın.",
              "records": "{count} kayıt",
              "lastUpdated": "Son güncelleme {time}",
              "view": "Görüntüle",
              "hide": "Gizle",
              "loadingPivot": "Pivot veri yükleniyor...",
              "public": "Herkese açık",
              "private": "Özel"
            },
            "delete": {
              "title": "Tablo sil",
              "confirm": "Tablo \"{title}\" silmek istediğinizden emin misiniz?",
              "detail": "Bu tablo ve önbelleğindeki veriler kalıcı olarak silinir.",
              "cancel": "İptal",
              "confirmBtn": "Tablo sil"
            }
          }
        },
        "settings": {
          "title": "Ayarlar",
          "description": "Form ayarlarını yönetin",
          "formStatus": "Form Durumu",
          "basicSettings": "Temel Ayarlar",
          "notifications": {
            "noChanges": "Kaydedilecek değişiklik yok",
            "draftWarning": "Taslak formlar bu arayüzden değiştirilemez. Lütfen önce formu yayınlayın.",
            "stateChangeHint": "Form durumunu değiştirmek yeni gönderimlerin kabul edilip edilmeyeceğini etkiler.",
            "invalidState": "Geçersiz form durumu: {state}",
            "success": "{state} form durumu başarıyla değiştirildi",
            "error": "Form durumu değiştirilirken hata: {error}",
            "errorLog": "Form durumu değiştirilirken hata"
          },
          "version": {
            "title": "Sürüm",
            "notSpecified": "Belirtilmemiş",
            "history": "Sürüm geçmişi",
            "noHistory": "Sürüm geçmişi yok",
            "download": "İndir",
            "restore": "Geri Yükle",
            "uploadNew": "Yeni Sürüm Yükle",
            "author": "Yazar"
          },
          "dataCollectors": {
            "title": "Veri Toplayıcıları",
            "description": "Form veri toplama kullanıcı erişimini yönetin",
            "noCollectors": "Atanmış veri toplayıcı yok",
            "addCollector": "Toplayıcı Ekle",
            "editCollector": "Toplayıcıyı Düzenle",
            "removeCollector": "Toplayıcıyı Kaldır",
            "addCollectorModal": {
              "title": "Veri Toplayıcı Ekle",
              "placeholder": "Saplama: veri toplayıcı ekleme formu burada olacak"
            }
          },
          "publicAccess": {
            "title": "Herkese Açık Erişim",
            "description": "Web arayüzü üzerinden veri toplama için herkese açık bağlantı oluşturun",
            "publicLink": "Herkese Açık Bağlantı",
            "disable": "Devre Dışı Bırak",
            "requireAuth": "Kimlik doğrulama gerekli",
            "collectEmail": "E-posta topla",
            "limitSubmissions": "Yanıt sayısını sınırla",
            "maxSubmissions": "Maksimum yanıt sayısı",
            "updateSettings": "Ayarları Güncelle",
            "createLink": "Herkese Açık Bağlantı Oluştur",
            "notCreated": "Herkese açık bağlantı oluşturulmadı. Web arayüzü üzerinden veri toplama için bağlantı oluşturun.",
            "created": "Herkese açık bağlantı oluşturuldu",
            "copied": "Bağlantı panoya kopyalandı",
            "disabled": "Herkese açık bağlantı devre dışı",
            "updated": "Herkese açık bağlantı ayarları güncellendi"
          },
          "qrCodes": {
            "title": "Veri Toplama için QR Kodları",
            "description": "Bu form için veri toplama cihazlarını yapılandırmak üzere QR kodlarını yönetin",
            "assignedTitle": "Atanmış QR Kodları",
            "availableTitle": "Mevcut Proje QR Kodları",
            "createNew": "Yeni QR Kod Oluştur",
            "noAvailable": "Mevcut QR kod yok",
            "createInstruction": "Veri toplama cihazlarını yapılandırmak için QR kodu oluşturun",
            "manageOnProject": "ODK Collect QR kodları proje düzeyinde yönetilir (App Users).",
            "openProjectQr": "Proje QR kodlarını aç",
            "openFormAccess": "Form erişimini yönet",
            "notifications": {
              "assigned": "QR kod forma atandı",
              "unassigned": "QR kod formdan kaldırıldı",
              "copied": "Base64 panoya kopyalandı",
              "copyError": "Kopyalama hatası: {error}"
            }
          },
          "attachments": {
            "title": "Ekler ve Medya Dosyaları",
            "description": "Formla ilişkili dosya ve ekleri yönetin",
            "xlsformFile": "XLSForm Dosyası",
            "xlsformDescription": "Bu form için orijinal XLSForm dosyasını Excel biçiminde indirin",
            "downloadXlsform": "XLSForm İndir",
            "manageAttachments": "Ekleri Yönet",
            "downloadSuccess": "XLSForm dosyası başarıyla indirildi",
            "downloadError": "XLSForm dosyası indirilirken hata",
            "fileNotFound": "Bu form için XLSForm dosyası bulunamadı",
            "accessDenied": "XLSForm dosyasını indirme erişimi yok",
            "serverError": "Sunucu hatası: {status}"
          },
          "analytics": {
            "title": "Analitik Yönetimi",
            "recreateAnalytics": "Analitiği Zorla Yeniden Oluştur",
            "description": "Tüm form gönderimleri için analitik verileri yeniden oluşturun. Analitik veriler bozulduğunda veya eksik olduğunda kullanın.",
            "warning": "Bu işlem tüm mevcut analitiği silecek ve ham gönderim verilerinden yeniden oluşturacaktır.",
            "confirmTitle": "Analitik Yeniden Oluşturmayı Onayla",
            "alertTitle": "Uyarı: Veri Yeniden Oluşturma Gerekli",
            "alertDescription": "Bu işlem tüm mevcut analitik verileri kalıcı olarak silecek ve sıfırdan yeniden oluşturacaktır.",
            "whatWillHappen": "Ne olacak:",
            "step1": "Tüm mevcut analitik veriler silinecek",
            "step2": "Ham gönderim verileri yeniden işlenecek",
            "step3": "Doğru biçimlendirmeyle yeni analitik veriler oluşturulacak",
            "step4": "Özet tablolar ve analiz özellikleri düzgün çalışacak",
            "timeWarning": "Bu işlem çok sayıda gönderimi olan formlar için birkaç dakika sürebilir.",
            "recreateButton": "Analitiği Zorla Yeniden Oluştur",
            "confirmButton": "Evet, Analitiği Yeniden Oluştur",
            "success": "Analitik başarıyla yeniden oluşturuldu! {total} toplam gönderimden {processed} işlendi, {recreated} analitik kaydı oluşturuldu.",
            "error": "Analitik veriler yeniden oluşturulamadı",
            "apiError": "API Hatası: {error}"
          },
          "dangerZone": {
            "title": "Tehlikeli Bölge",
            "deleteForm": "Formu Sil",
            "description": "Bu işlem geri alınamaz. Tüm toplanan veriler kaybolacaktır.",
            "confirmDelete": "Form Silmeyi Onayla",
            "confirmMessage": "\"{name}\" formunu silmek istediğinizden emin misiniz?",
            "confirmDescription": "Bu işlem geri alınamaz. Tüm toplanan veriler kaybolacaktır.",
            "enterFormName": "Onay için form adını girin",
            "deleteFormButton": "Formu Sil",
            "formDeleted": "Form silindi (saplama işlev)"
          }
        },
        "datasets": {
          "title": "Veri Kümeleri",
          "description": "Veri kümesi ve varlık yönetimi"
        }
      },
      "errors": {
        "missingParams": "Form yüklemek için gerekli parametreler eksik",
        "loadError": "Form verileri yüklenirken hata",
        "unknownError": "Bilinmeyen hata"
      }
    },
    "dashboard": {
      "loading": "Analitik yükleniyor...",
      "analyticsError": "Analitik yüklenirken hata",
      "retry": "Yüklemeyi tekrar dene",
      "workbench": {
        "contextHint": "Form kimliği, toplama, zaman çizelgesi ve AI — paylaşılan dönem (7 / 30 / all) için.",
        "completionBadge": "%{rate} tamamlanma",
        "metaVersion": "v{version}",
        "metaPublished": "yay. {date}",
        "metaUpdated": "gün. {date}",
        "summaryTitle": "Toplama özeti",
        "sections": {
          "metadata": {
            "title": "Form kimliği",
            "xmlFormId": "XML form kimliği",
            "version": "Sürüm",
            "published": "Yayınlandı",
            "updated": "Son güncelleme"
          },
          "intake": {
            "title": "Toplama özeti",
            "subtitle": "Bugün, bu hafta ve toplam gönderimler"
          },
          "quickLinks": {
            "title": "Hızlı bağlantılar"
          },
          "agent": {
            "title": "AI asistanı",
            "subtitle": "Özetler, analitik raporlar veya bu form hakkında sohbet"
          },
          "timeline": {
            "title": "Gönderim zaman çizelgesi",
            "subtitle": "Seçilen dönemde günlük gönderim hacmi"
          },
          "map": {
            "title": "Coğrafi dağılım",
            "subtitle": "Geo verili gönderim konumları"
          }
        },
        "metrics": {
          "noChange": "Değişiklik yok"
        },
        "intakeStrip": {
          "ariaLabel": "Veri toplama durumu",
          "today": "Bugün",
          "todayDelta": "{delta} düne göre",
          "todayFlat": "Dünle aynı",
          "week": "Bu hafta",
          "weekDelta": "{delta} geçen haftaya göre",
          "weekFlat": "Geçen haftayla aynı",
          "total": "Tüm yanıtlar",
          "totalHint": "Bu form için toplanan toplam",
          "totalEmpty": "Henüz yanıt yok"
        }
      },
      "cards": {
        "totalSubmissions": {
          "title": "Toplam Gönderim",
          "today": "bugün"
        },
        "completedSubmissions": {
          "title": "Tamamlanan Gönderimler",
          "rate": "tamamlanma oranı"
        },
        "dataCollectors": {
          "title": "Veri Toplayıcıları",
          "new": "yeni"
        },
        "problematicSubmissions": {
          "title": "Sorunlu Gönderimler"
        },
        "submissionTimeline": {
          "title": "Gönderim Zaman Çizelgesi",
          "totalForPeriod": "Dönem toplamı",
          "noData": "Gönderim zaman çizelgesi verisi yok",
          "noSubmissionsInPeriod": "Seçilen dönem için gönderim yok",
          "stats": {
            "totalSubmissions": "Toplam gönderim",
            "maxPerDay": "Günlük maks.",
            "trend": "Eğilim"
          },
          "timeframes": {
            "7days": "Son 7 gün",
            "30days": "Son 30 gün",
            "90days": "Son 90 gün"
          },
          "trend": {
            "stable": "Değişiklik yok",
            "growth": "Artış",
            "decline": "Azalış"
          },
          "hint": "Günün ayrıntılı bilgisi için bir çubuğa tıklayın"
        }
      }
    },
    "summaryCard": {
      "id": "ID",
      "statusNotSet": "Durum ayarlanmamış",
      "statusDescriptions": {
        "published": "Form veri toplama için açık",
        "closing": "Form kapanıyor, yeni yanıtlar sınırlı",
        "closed": "Form kapalı, yeni yanıtlar kabul edilmiyor",
        "draft": "Form taslak modunda, yayınlanmamış",
        "unknown": "Durum tanınmadı"
      },
      "stats": {
        "today": "Bugün",
        "week": "Bu hafta",
        "total": "Toplam toplanan",
        "responses": "form yanıtı",
        "fromYesterday": "dünden",
        "fromLastWeek": "geçen haftadan"
      },
      "info": {
        "version": "Sürüm",
        "notSpecified": "Belirtilmemiş",
        "created": "Oluşturuldu",
        "updated": "Güncellendi",
        "notUpdated": "Güncellenmedi",
        "published": "Yayınlandı",
        "notPublished": "Yayınlanmadı",
        "notSpecifiedDate": "Belirtilmemiş"
      },
      "trend": {
        "title": "Son 7 günün doldurma eğilimi",
        "noData": "Veri yok",
        "growth": "Artış",
        "decline": "Azalış",
        "stable": "Değişiklik yok"
      }
    },
    "attachments": {
      "title": "Form Ekleri",
      "formLabel": "Form:",
      "noAttachmentsRequired": "Ek Gerekmiyor",
      "noAttachmentsDescription": "Bu form harici dosyalara (görseller, belgeler vb.) referans içermiyor.",
      "noAttachmentsHint": "XLSForm'a dosya referansları eklerseniz burada otomatik görünecektir.",
      "uploadSection": {
        "supportedFormats": "Desteklenen biçimler:",
        "dropZoneTitles": {
          "uploadMissing": "Eksik dosyaları yükle",
          "updateExisting": "Mevcut dosyaları güncelle",
          "uploadFiles": "Dosya yükle"
        },
        "dropZoneDescriptions": {
          "uploadMissing": "Beklenen {count} dosya: {files}",
          "updateExisting": "Tüm dosyalar yüklendi. Yeni sürümlerle değiştirebilirsiniz.",
          "uploadFiles": "Form eklerini yüklemek için dosya seçin."
        },
        "dropZoneButtons": {
          "selectFiles": "Dosya seç",
          "updateFiles": "Dosyaları güncelle",
          "chooseFiles": "Dosya seç"
        },
        "selectedFiles": "Seçilen dosyalar ({count})",
        "uploadButton": "{count} dosya yükle",
        "uploading": "Yükleniyor...",
        "clear": "Temizle",
        "chooseFiles": "Dosya seç"
      },
      "table": {
        "columns": {
          "name": "Dosya Adı",
          "status": "Durum",
          "type": "Tür",
          "size": "Boyut",
          "updatedAt": "Yükleme Tarihi",
          "actions": "İşlemler"
        },
        "status": {
          "uploaded": "Yüklendi",
          "missing": "Eksik",
          "deleted": "Silindi",
          "unknown": "Bilinmiyor"
        },
        "actions": {
          "download": "İndir",
          "delete": "Sil",
          "deleted": "Silindi",
          "missing": "Eksik"
        },
        "notSpecified": "Belirtilmemiş"
      },
      "messages": {
        "uploadSuccess": "{count} dosya başarıyla yüklendi",
        "uploadError": "Dosyalar yüklenirken hata: {error}",
        "fileNotFound": "{filename} dosyası seçilen dosyalarda bulunamadı",
        "fileUploadSuccess": "{filename} dosyası başarıyla yüklendi",
        "fileUploadError": "{filename} dosyası yüklenirken hata: {error}",
        "downloadError": "{filename} dosyası indirilirken hata: {error}",
        "deleteSuccess": "{filename} dosyası başarıyla silindi",
        "deleteError": "{filename} dosyası silinirken hata: {error}",
        "invalidFilesIgnored": "Aşağıdaki dosyalar yoksayılacak (beklenen listede bulunamadı): {files}",
        "filesWillBeUpdated": "Aşağıdaki dosyalar güncellenecek: {files}",
        "loadingError": "Ekler yüklenirken hata",
        "downloadSuccess": "{filename} dosyası başarıyla indirildi",
        "fileAlreadyDeleted": "{filename} dosyası zaten silindi veya mevcut değil",
        "fileNotInExpectedList": "Dosya beklenen ek listesinde bulunamadı"
      },
      "confirmDelete": {
        "title": "Silmeyi Onayla",
        "message": "\"{filename}\" dosyasını silmek istediğinizden emin misiniz?",
        "warning": "Bu işlem geri alınamaz.",
        "deleting": "Siliniyor...",
        "delete": "Sil"
      }
    }
  },
  "pageNotFound": {
    "title": "Hata! Sayfa bulunamadı.",
    "subtitle": "404",
    "description": "Aradığınız sayfa mevcut değil veya taşınmış.",
    "goBack": "Geri Dön",
    "goHome": "Ana Sayfaya Git",
    "copyright": "© {year} UDACAPI. Tüm hakları saklıdır."
  },
  "maps": {
    "tabTitle": "Harita",
    "pageTitle": "Proje Haritası",
    "subtitle": "GPS etiketli gönderimleri gerçek zamanlı izleyin",
    "empty": {
      "noGeoForms": "Bu projedeki hiçbir formda henüz GPS sorusu yok.",
      "noPoints": "Mevcut filtrelere uyan gönderim yok."
    },
    "filters": {
      "title": "Filtreler",
      "forms": "Formlar",
      "dateFrom": "Başlangıç",
      "dateTo": "Bitiş",
      "qcStatus": "QC Durumu",
      "enumerator": "Veri toplayıcı",
      "heatmap": "Isı haritası",
      "reset": "Filtreleri sıfırla",
      "apply": "Uygula"
    },
    "qcStatuses": {
      "any": "Tümü",
      "pass": "Geçti",
      "fail": "Başarısız",
      "warning": "Uyarı",
      "error": "Hata",
      "none": "Doğrulanmadı"
    },
    "actions": {
      "export": "GeoJSON dışa aktar",
      "refresh": "Yenile",
      "settings": "Harita ayarları",
      "openSubmission": "Gönderimi aç",
      "openFormOnMap": "Formu haritada görüntüle"
    },
    "popup": {
      "submittedAt": "Gönderim zamanı",
      "submittedBy": "Gönderen",
      "form": "Form",
      "status": "QC Durumu"
    },
    "truncated": "İlk {limit} nokta gösteriliyor. Daha fazlasını görmek için filtreleri daraltın veya kümelemeyi etkinleştirin.",
    "settingsDialog": {
      "title": "Proje harita ayarları",
      "defaultCenter": "Varsayılan merkez",
      "defaultCenterHint": "Bir konum seçmek için haritaya tıklayın",
      "defaultZoom": "Varsayılan yakınlaştırma",
      "defaultForms": "Varsayılan formlar",
      "heatmapDefault": "Isı haritasını varsayılan olarak göster",
      "coordinateFields": "Koordinat alanları",
      "latitudeField": "Enlem alanı",
      "longitudeField": "Boylam alanı",
      "automaticDetection": "Otomatik algılamayı kullan",
      "coordinateSourceTitle": "Koordinat kaynağı",
      "coordinateMode": "Koordinat modu",
      "modeAuto": "Otomatik algılama",
      "modeNone": "Konum verisi yok",
      "modeLatLon": "Enlem ve boylam alanları",
      "modeGeopoint": "Geopoint alanı",
      "geopointField": "Geopoint alanı",
      "detectedSource": "Algılanan kaynak: {path} · mevcut noktalar: {count}",
      "configureCoordinates": "Koordinat alanları",
      "noMapHint": "Bu form için harita noktası yok. Gönderimlerde konum varsa koordinat alanlarını yapılandırın.",
      "save": "Kaydet",
      "cancel": "İptal",
      "saved": "Ayarlar kaydedildi"
    },
    "savedViews": {
      "title": "Kaydedilmiş görünümler",
      "noViewsYet": "Kayıtlı görünüm yok — proje haritasından oluşturun",
      "recommended": "Önerilen",
      "defaultLabel": "varsayılan",
      "saveHint": "Uygula sonrası harita filtrelerinizi ve ısı haritasını kullanır. «Geçerli görünümü kaydet» bu yapılandırmayı adla kaydeder (yalnızca proje yöneticileri).",
      "saveCurrent": "Geçerli görünümü kaydet",
      "updateCurrent": "Görünümü güncelle",
      "delete": "Görünümü sil",
      "name": "Görünüm adı",
      "pinAsDefault": "Varsayılan olarak sabitle",
      "pin": "Görünümü sabitle",
      "saved": "Görünüm kaydedildi",
      "updated": "Görünüm güncellendi",
      "deleted": "Görünüm silindi",
      "saveFailed": "Görünüm kaydedilemedi. API dağıtılmış ve DB migrations proje_map_views içeriyor mu kontrol edin.",
      "updateFailed": "Görünüm güncellenemedi.",
      "deleteFailed": "Görünüm silinemedi."
    },
    "tileConfig": {
      "sectionTitle": "Harita karo sunucusu",
      "sectionDescription": "Kuruluşunuz için özel bir karo sunucusu URL'si sağlayın. Genel OpenStreetMap karolarını kullanmak için boş bırakın.",
      "url": "Karo URL şablonu",
      "urlPlaceholder": "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      "attribution": "Atıf",
      "subdomains": "Alt alan adları",
      "maxZoom": "Maks. yakınlaştırma",
      "minZoom": "Min. yakınlaştırma",
      "test": "URL'yi test et",
      "configure": "Yapılandır",
      "edit": "Düzenle",
      "defaultTiles": "OpenStreetMap genel karoları kullanılıyor",
      "zoom": "Yakınlaştırma",
      "clear": "Temizle",
      "save": "Kaydet",
      "saved": "Karo yapılandırması kaydedildi",
      "cleared": "Özel karo sunucusu temizlendi"
    }
  },
  "help": {
    "title": "Yardım",
    "subtitle": "UDACAPI'de yaygın görevler için kısa kılavuzlar ve yanıtlar.",
    "searchPlaceholder": "Kılavuz ve soru ara…",
    "learnMore": "Daha fazla bilgi",
    "openGuide": "Aç",
    "openGuideFormScope": "Panoyu aç — ardından bir proje ve form seçin",
    "whenToUse": "Ne zaman kullanılır",
    "steps": "Adımlar",
    "comingSoon": "Analiz, izleme ve kuruluş ayarları için daha fazla kılavuz yakında.",
    "noResults": "Aramanızla eşleşen kılavuz yok.",
    "featureGuides": {
      "odkServers": {
        "title": "ODK Sunucuları",
        "summary": "UDACAPI'nin projeleri ve gönderimleri senkronize edebilmesi için ODK Central (veya uyumlu) sunucunuzu bağlayın.",
        "whenToUse": "İlk kurulum, senkronizasyon veya içe aktarmadan önce.",
        "steps": [
          "Kenar çubuğunda ODK Sunucuları'nı açın.",
          "Sunucu URL'si ve kimlik bilgilerini ekleyin.",
          "Bağlantıyı test et'i çalıştırın.",
          "Senkronize etmeden önce URL, kimlik bilgileri veya ağ sorunlarını düzeltin."
        ]
      },
      "sync": {
        "title": "Sync Workbench",
        "summary": "ODK'dan yeni gönderimleri alın ve form yapısını güncelleyin.",
        "whenToUse": "Sunucu bağlandıktan sonra; yeni saha verisi beklediğinizde.",
        "steps": [
          "Sync Workbench'i açın.",
          "Sunucu, proje ve form seçin.",
          "İmleç ve son senkron durumunu inceleyin.",
          "Senkronizasyonu başlatın ve tamamlanmasını bekleyin.",
          "Formu açın — Overview, Export veya QC."
        ]
      },
      "import": {
        "title": "Proje ve form içe aktarma",
        "summary": "Mevcut ODK projelerini ve formlarını kuruluşunuza getirin.",
        "whenToUse": "ODK'dan geçiş veya yeni sunucu devreye alma.",
        "steps": [
          "ODK sunucusunun bağlı ve test edilmiş olduğundan emin olun.",
          "Projeler'den İçe aktar'ı başlatın (yalnızca kuruluşa ait sunucular).",
          "Bir proje seçin ve formları içe aktarın.",
          "Bir form açın ve Overview ile Settings'i doğrulayın."
        ]
      },
      "xlsformAssist": {
        "title": "XLSForm Assist",
        "summary": "XLSForm değişikliklerini taslaklamak, önizlemek ve yayınlamak için AI workbench.",
        "whenToUse": "Yeni anketler veya büyük şema değişiklikleri.",
        "steps": [
          "Bir proje açın ve XLSForm Assist'i başlatın.",
          "Anketi tanımlayın veya soru dosyası yükleyin.",
          "ODK Web Forms önizlemesini inceleyin.",
          "Yayını onaylayın ve işin bitmesini bekleyin."
        ]
      },
      "formOverview": {
        "title": "Form Overview",
        "summary": "Seçilen dönem için toplama, zaman çizelgesi, harita ve AI soru-cevap özeti.",
        "whenToUse": "Günlük izleme; canlı form verisi hakkında hızlı sorular.",
        "steps": [
          "Bir form açın ve Overview'a gidin.",
          "Dönemi seçin (7 / 30 / all) — AI raporları ve zaman çizelgesiyle paylaşılır.",
          "Zaman çizelgesi ve haritayı inceleyin.",
          "Aynı pencere için AI sohbeti veya özet raporlar oluşturun."
        ]
      },
      "autoReports": {
        "title": "Otomatik raporlar",
        "summary": "Form başına zamanlanmış ve isteğe bağlı AI raporları, email ile teslim.",
        "whenToUse": "Düzenli paydaş güncellemeleri (haftalık veya aylık).",
        "steps": [
          "Org → Rapor şablonları — şablon oluşturun veya seçin.",
          "Form → Otomatik raporlar — zamanlama ve alıcıları ayarlayın.",
          "Dönemli manuel önizleme için Generate kullanın.",
          "Önizlemeden sonra teslim için Send kullanın."
        ]
      },
      "qc": {
        "title": "Kalite kontrol (QC)",
        "summary": "Gönderimlerde doğrulama kuralları; AI başlangıç paketi önerebilir.",
        "whenToUse": "İlk gönderimlerden sonra; dışa aktarma veya analize güvenmeden önce.",
        "steps": [
          "Bir form açın ve QC'ye gidin.",
          "Kural oluşturun veya AI önerisini kullanın.",
          "Doğrulamayı çalıştırın.",
          "İşaretlenen gönderimleri inceleyin."
        ]
      },
      "export": {
        "title": "Veri dışa aktarma",
        "summary": "Gönderimleri CSV, Excel ve daha fazlasına aktarın; büyük formlar asenkron iş kullanır.",
        "whenToUse": "Excel, SPSS, Stata veya harici pipeline'lara aktarım.",
        "steps": [
          "Bir form açın ve Data Export'a gidin.",
          "Biçim ve seçenekleri seçin.",
          "Dışa aktarmayı başlatın ve işi bekleyin.",
          "Dosyayı iş listesinden indirin."
        ]
      }
    },
    "faq": {
      "title": "Sık sorulan sorular",
      "items": {
        "sync-no-new-data": {
          "question": "Senkronizasyon neden yeni gönderimleri çekmiyor?",
          "answer": "ODK sunucusunun erişilebilir olduğunu, senkron imlecinin eski bir konumda takılı kalmadığını, doğru formu seçtiğinizi ve hesabınızın o projeye erişebildiğini kontrol edin. Sunucuda Bağlantıyı test et'i çalıştırın, ardından Sync Workbench'ten senkronu yeniden deneyin."
        },
        "sync-cursor": {
          "question": "Senkron imleci nedir?",
          "answer": "İmleç, artımlı senkron işaretçisidir — UDACAPI'nin gönderimleri okumayı en son nerede bıraktığı. İmleci sıfırlamak veya hizasız bırakmak veriyi atlayabilir veya yeniden çekebilir; tam yeniden senkron zorlamadan önce Sync Workbench'te imleç durumunu inceleyin."
        },
        "import-server-type": {
          "question": "Bu sunucudan neden içe aktaramıyorum?",
          "answer": "Proje içe aktarma yalnızca kuruluşa ait ODK sunucularında izinlidir. Shared ve Global sunucular içe aktarma için kullanılamaz — org sunucusu bağlayın veya yöneticinize danışın."
        },
        "import-how": {
          "question": "Mevcut bir ODK projesini nasıl içe aktarırım?",
          "answer": "Sunucuyu bağlayıp test edin, ardından Projeler → İçe aktar'a gidin, projeyi seçin ve formları içe aktarın. Adım adım talimatlar için yukarıdaki Proje ve form içe aktarma kılavuzuna bakın."
        },
        "xlsform-where": {
          "question": "XLSForm Assist nerede?",
          "answer": "Projeler'den bir proje açın, ardından proje formları alanından (veya o proje için ayrılmış assist rotasından) XLSForm Assist'i başlatın."
        },
        "ai-scope": {
          "question": "Form AI'si neye yanıt verebilir?",
          "answer": "Form şeması, gönderimler, analitik, QC kuralları ve senkron durumu hakkında sorular — o formun canlı verilerine dayanır. QC onayının veya kişisel verilerin hukuki incelemesinin yerini tutmaz."
        },
        "ai-quota": {
          "question": "Neden kota aşıldı görüyorum?",
          "answer": "Kuruluşunuz bir agent kullanım limitine ulaştı. Sıfırlama penceresini bekleyin veya limitleri ayarlamak için kuruluş sahibi veya yöneticinize başvurun."
        },
        "auto-generate-vs-schedule": {
          "question": "Generate ile zamanlanmış rapor arasındaki fark nedir?",
          "answer": "Generate, formda seçtiğiniz dönem için isteğe bağlı çalışır. Zamanlanmış çalıştırmalar şablon cron'unu izler ve zamanlamayla hizalı veri penceresini kullanır — Overview dönem seçicisiyle aynı olmak zorunda değildir."
        },
        "auto-templates": {
          "question": "Rapor şablonları nerede yönetilir?",
          "answer": "Kuruluş düzeyinde: Kuruluşum → Rapor şablonları (veya hızlı şablon bağlantısı). Şablonlar org merkezlidir; her formun Otomatik raporlar sekmesi o formu kapsayan şablonları gösterir."
        },
        "qc-first-rule": {
          "question": "İlk QC kuralımı nasıl oluştururum?",
          "answer": "Form → QC → Kural oluştur'a gidin veya form yapısından başlangıç paketi taslaklamak için AI önerisini kullanın, ardından doğrulamayı çalıştırın."
        },
        "export-slow": {
          "question": "Dışa aktarma uzun sürüyor — bu normal mi?",
          "answer": "Büyük formlar için evet. Dışa aktarmalar arka plan işi olarak çalışır. Sayfayı açık tutun veya iş tamamlandığında indirmek için Data Export'a dönün."
        },
        "export-where": {
          "question": "Dışa aktarılan dosyam nerede?",
          "answer": "Formun Data Export sekmesinde — iş durumu complete olduğunda indirme eylemi olan iş/geçmiş listesinde."
        },
        "permissions-missing": {
          "question": "Bir proje veya sekme göremiyorum",
          "answer": "İzin grubunuz o projeyi veya özelliği kapsamıyor olabilir. Kuruluş sahibinizden izin gruplarını ve proje erişimini gözden geçirmesini isteyin."
        }
      }
    },
    "support": {
      "title": "Daha fazla yardıma mı ihtiyacınız var?",
      "body": "Bu kılavuzlar sorununuzu çözmezse UDACAPI desteğiyle iletişime geçin.",
      "contactLabel": "Desteğe email gönder"
    }
  }
}
